export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Cartier Philanthropy Rapport Annuel 2019-2020",
    "shortTitle": "",
    "description": "",
    "width": 724,
    "height": 900,
    "currentLanguage": "FR",
    "languages": [
      {
      code: "EN",
      text: "English",
      href: "https://reports.cartierphilanthropy.org/AR2019-20/en"
      },
      {
      code: "FR",
      text: "French",
      href: "https://reports.cartierphilanthropy.org/AR2019-20/fr"
      }
    ],
    // "basePath": "",
    "basePath": "/AR2019-20/fr",
    "companyLogo": "cp-logo.png",
    "publishURL": "https://reports.cartierphilanthropy.org/AR2019-20/fr/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": true,
      "downloadPath": '/AR2019-20/fr/static/_content/Cartier-Philanthropy_Rapport-Annuel-2019-2020.pdf',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {},
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 1-title" style="top:800px; left:1167px;" src="/AR2019-20/fr/static/_content/1-title-1.png">        
      <img class="halfScaleC 1-logo" style="top:278px;left:1033px;" src="/AR2019-20/fr/static/_content/1-logo-1.png">        
      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(cOf("1-logo"), 0.6, {opacity:0, scale: 0}, {opacity:1, scale: 0.5, ease: Power2.easeOut}, 1)
          pg1Anim.fromTo(cOf("1-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "RAPPORT ANNUEL  2019 - 2020"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      <img class="halfScaleC 2-pie" style="top:-9px;left:236px;" src="/AR2019-20/fr/static/_content/2-pie-1.png">
      <img class="halfScaleC 2-pie" style="top:154px;left:-14px;" src="/AR2019-20/fr/static/_content/2-pie-2.png">
      <img class="halfScaleC 2-pie" style="top:221px;left:333px;" src="/AR2019-20/fr/static/_content/2-pie-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim.staggerFromTo(cOf("2-pie"), 1, {scale: 0}, {scale: 0.5, ease: Bounce.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg2Anim.stop();
        }
      `,
      "searchText": "Distribution  ALLOCATION  géographique  BUDGÉTAIRE  53.5% 29% 11%  Amérique Latine  3.5% 2% 1%  Par secteur 44%  Global  Europe (Covid-19) Moyen-Orient  Services de base  Services de base  23%  Modes de subsistance  22%  Développement social et économique des femmes  11%  Afrique  Asie  20%  Santé  24%  Nutrition  30%  Éducation  26%  Eau  Urgences MSF  RDC  NOUVELLE DONATION  NOUVELLE DONATION  Buildher  Muso  Kenya  Mali NOUVELLE DONATION  Room to Read  Bangladesh, Cambodge NOUVELLE DONATION  Saha Global  DONATION DE SUIVI  NOUVELLE DONATION  BRAC  BOMA Project  Ouganda  Kenya  NOUVELLE DONATION  Healthy Learners  Zambie NOUVELLE DONATION  SOIL  Haïti  Ghana  DONATION DE SUIVI  DONATION DE SUIVI  Kheyti  Root Capital  Inde  Pérou  DONATION DE SUIVI  Tostan  Sénégal, Gambie, Guinée-Bissau  Avril  Mission en Jordanie, Liban  IECD, PAM  Juillet Mission en Zambie, Kenya  Buildher, mothers2mothers, StrongMinds  Août  Octobre  Mission à Madagascar  Blue Ventures, IECD, Pivot, WSUP  2019  Novembre Mission au Bangladesh  Asian University for Women, BRAC, Room to Read, VisionSpring"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <h1 id="3-no1" class="abs brillcutreg 3-no" style="left:77px;top:64px;font-size:4.4em;font-weight:400;margin:0;color:#808285;padding:0;margin:0;"  data-number='{"to": 65, "comma": true}'></h1>
        <h1 id="3-no2" class="abs brillcutreg 3-no" style="left:262px;top:148px;font-size:4.4em;font-weight:400;margin:0;color:#808285;padding:0;margin:0;"  data-number='{"to": 40, "comma": true}'></h1>
        <h1 id="3-no3" class="abs brillcutreg 3-no" style="left:191px;top:252px;font-size:4.4em;font-weight:400;margin:0;color:#808285;padding:0;margin:0;"  data-number='{"to": 29, "comma": true}'></h1>
      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
            pg3Anim.fromTo(cOf("3-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("3-no")[0]);}}, 1)
            .fromTo(cOf("3-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("3-no")[1]);}}, "+=0.2")
            .fromTo(cOf("3-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("3-no")[2]);}}, "+=0.2")
      }

      function onPageLeave() {
        pg3Anim.stop();
        resetNumbers("3-no");
        removeContentLinks();
      }
      `,
      "searchText": "65  million de francs Suisse investis à ce jour  40 29  partenaires  pour un avenir plus fort  pays  à faible revenu  RÉPONSE À L’URGENCE MSF  MSF  Niger, RDC  Belgique, France, Espagne, Grèce, Italie, Suisse  SOS MÉDITERRANÉE  Mer Méditerranée  Visiting Nurse Service of New York, Harlem Children’s Zone, DonorsChoose  États Unis TECHO  Brésil, Colombie, Mexique  DONATIONS  DONATION DE SUIVI  One Acre Fund  Rwanda NOUVELLE DONATION  IECD  Liban  DONATION DE SUIVI  DONATION DE SUIVI  Village Enterprise  Ouganda  IECD  DONATION DE SUIVI  Madagascar  mothers2mothers  Ouganda DONATION DE SUIVI  StrongMinds  Zambie  Décembre  Janvier  Février  Mars  Mai  2020 MISSIONS"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 4-block" style="top:496px;left:122px;" src="/AR2019-20/fr/static/_content/4-block-1.png">
      <img class="halfScale 4-block" style="top:214px;left:449px;" src="/AR2019-20/fr/static/_content/4-block-2.png">
      <img class="halfScale 4-block" style="top:64px;left:542px;" src="/AR2019-20/fr/static/_content/4-block-4.png">
      
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim.fromTo(cOf("4-block")[0], 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("4-block")[1], 0.6, {opacity:0,x: 60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.4)
          .fromTo(cOf("4-block")[2], 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
        pg4Anim.stop();
        }
      `,
      "searchText": "BELGIQUE ESPAGNE FRANCE GRÈCE ITALIE SUISSE I  LES PROGRAMMES QUE  NOUS SOUTENONS  Axe : Réponse à l’urgence Partenaire : MSF  MAROC  I  MALI  I  SÉNÉGAL  I  GAMBIE  I  GUINÉE-BISSAU  I  BURKINA FASO  I  Axe : Modes de subsistance Partenaire : Education for Employment  Axe : Accès aux services de base (santé) Partenaire : Muso  Axes : Accès aux services de base (santé), Développement social et économique des femmes, Modes de subsistance Partenaires : Amref, MSI, myAgro, Tostan  Axe : Développement social et économique des femmes Partenaire : Tostan  MEXIQUE  I  Axe : Développement social et économique des femmes Partenaire : CREA  GUATEMALA  I  Axe : Accès aux services de base (nutrition) Partenaire : Semilla Nueva  HAÏTI  I  PÉROU  I  Axe : Accès aux services de base (eau) Partenaire : SOIL  Axe : Développement social et économique des femmes Partenaire : Tostan  Axe : Accès aux services de base (éducation, nutrition) Partenaire : PAM  GHANA  I  Axe : Accès aux services de base (eau) Partenaire : Saha Global  TOGO  I  NIGER  I  Axe : Accès aux services de base (santé) Partenaire : Santé Intégrée  Axe : Réponse à l’urgence Partenaire : MSF  RDC I  Axe : Modes de subsistance Partenaires : Root Capital, Terre des Hommes Suisse  Axe : Réponse à l’urgence Partenaire : MSF  ZAMBIE  I  Axes : Accès aux services de base (santé), Développement social et économique des femmes Partenaires : Healthy Learners, StrongMinds"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 5-block" style="top:63px; left:0px;" src="/AR2019-20/fr/static/_content/5-block-2.png">
      <img class="halfScale 5-block" style="top:398px; left:243px;" src="/AR2019-20/fr/static/_content/5-block-3.png">
      <img class="halfScale 5-block" style="top:63px; left:0px;" src="/AR2019-20/fr/static/_content/5-block-4.png">
      
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.fromTo(cOf("5-block")[0], 0.6, {opacity:0,x:60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.4)
          .fromTo(cOf("5-block")[1], 0.6, {opacity:0,x: 60}, {opacity:1,x:0, ease: Power2.easeOut}, 1.8)
          .fromTo(cOf("5-block")[2], 0.6, {opacity:0,x:-60}, {opacity:1,x:0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
        pg5Anim.stop();
        }
      `,
      "searchText": "I  KOSOVO  I  Axe : Développement social et économique des femmes Partenaire : Women for Women International  I  MER MEDITÉRRANÉE I  Axe : Réponse à l’urgence Partenaire : SOS Méditerranée  LIBAN  I  Axe : Accès aux services de base (éducation) Partenaire : IECD  JORDANIE  Axe : Accès aux services de base (éducation, nutrition) Partenaire : PAM  OUGANDA  Axes : Accès aux services de base (eau), Développement social et économique des femmes, Modes de subsistance Partenaires : BRAC, FICR, mothers2mothers, Village Enterprise I  ÉTHIOPIE  Axe : Accès aux services de base (éducation) Partenaire : Luminos Fund  I  INDE  Axes : Accès aux services de base (éducation), Développement social et économique des femmes, Modes de subsistance Partenaires : Azad Foundation, Educate Girls, Kheyti I  I  KENYA  I I  RWANDA  Axes : Développement social et économique des femmes, Modes de subsistance Partenaires : One Acre Fund, Women for Women International  TANZANIE  Axe : Développement social et économique des femmes Partenaire : Hand in Hand International I  MOZAMBIQUE  Axe : Accès aux services de base (éducation, nutrition) Partenaire : PAM  I  MADAGASCAR  Axes : Accès aux services de base (eau, éducation), Modes de subsistance Partenaires : Blue Ventures, IECD, WSUP  MYANMAR  Axes : Accès aux services de base (eau), Développement social et économique des femmes, Modes de subsistance Partenaires : FICR, Proximity Designs, SAD I  I  BANGLADESH  Axes : Accès aux services de base (éducation, santé), Réponse à l’urgence Partenaires : AUW, BRAC, Room to Read, VisionSpring  Axes : Accès aux services de base (santé), Développement social et économique des femmes Partenaires : BOMA Project, Buildher, Living Goods  CAMBODGE  Axe : Accès aux services de base (eau, éducation) Partenaires : FICR, Room to Read"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "NOTRE AMBITION EST D’AIDER À LIBÉRER LE POTENTIEL DE CHACUN"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <div class="contentLinkNone" style="top:212px;left:319px;width:230px;height:64px;" onclick="Publish.goToPage(8)"></div>
        <div class="contentLinkNone" style="top:305px;left:319px;width:260px;height:64px;" onclick="Publish.goToPage(9)"></div>
        <div class="contentLinkNone" style="top:400px;left:319px;width:230px;height:64px;" onclick="Publish.goToPage(11)"></div>
        <div class="contentLinkNone" style="top:496px;left:319px;width:230px;height:76px;" onclick="Publish.goToPage(21)"></div>
        <div class="contentLinkNone" style="top:604px;left:319px;width:230px;height:76px;" onclick="Publish.goToPage(29)"></div>
        <div class="contentLinkNone" style="top:713px;left:319px;width:230px;height:76px;" onclick="Publish.goToPage(39)"></div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "SOMMAIRE  8 Message du président  9 Lettre de la directrice exécutive  11 Accès aux services de base  21  Développement social et économique des femmes  29  Modes de subsistance et écosystèmes durables  39  Réponse et préparation aux situations d’urgence"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 139px; left: 198px; width: 433px; height: 694px;" onclick="Publish.openArticle(0)"></div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
        }, 1000)
        }

        function onPageLeave() {
          removeContentLink();
          Publish.closeArticle();
        }
      `,
      "searchText": "MESSAGE DU PRÉSIDENT Quelle est la place du mécénat d’entreprise dans notre société ? La question est ancienne, et ses réponses multiples. L’engagement philanthropique de Cartier envers la société s’exprime à travers Cartier Philanthropy pour donner une dimension concrète à nos valeurs : générosité, confiance, respect et compassion. La fondation illustre notre implication sans équivoque dans la construction d’un monde plus inclusif et équitable, tout comme Cartier Women’s Initiative et d’autres actions fortes de notre Maison. Tout au long de l’année, Cartier Philanthropy s’évertue à apporter des solutions aux défis les plus prégnants dans les régions les moins développées du monde, nous rappelant ainsi que nous avons tous, individus comme entreprises, le potentiel — et donc le devoir — d’agir. À travers ses initiatives, la fondation nous encourage à faire face aux menaces, même les plus redoutables, avec rigueur et détermination. Pas parce que c’est ce que l’on attend de nous. Pas pour faire la une. Mais parce que c’est notre responsabilité de citoyens du monde. À l’heure où j’écris ces lignes, l’humanité affronte la pandémie du coronavirus. Partout, des gens se battent pour endiguer la maladie, sauver des vies, et maintenir leurs moyens de subsistance. Le virus nous a rappelé que, quels que soient nos sentiments de faiblesse et de vulnérabilité face au danger, nous sommes toujours entourés de personnes plus vulnérables que nous. Notre aide leur est essentielle. Nous ne pouvions donc que nous associer à l’effort humanitaire international déployé en Europe, en Amérique du Nord et du Sud, en Chine, au Moyen-Orient et en Asie du Sud-Est. Cet impératif s’est naturellement imposé dans la logique de l’approche philanthropique de Cartier, enracinée dans la compassion, le pragmatisme et l’ouverture d’esprit. Nous n’avons pourtant pas détourné notre attention des plus vulnérables. Comme vous le lirez dans ce rapport, nous avons élargi notre champ d’action pour soutenir le travail fourni sans relâche par Médecins Sans Frontières et d’autres organisations afin de venir en aide à celles et ceux qui sont ou étaient dans le besoin en Italie, en France, en Belgique, en Espagne, en Suisse et en Grèce. Une fois encore, Cartier Philanthropy nous a permis de répondre rapidement à une crise sans précédent, unis dans un esprit de solidarité pour agir efficacement en ces temps difficiles.  Cyrille Vigneron Président du conseil de fondation, Cartier Philanthropy PDG de Cartier 8"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 119px; left: 218px; width: 433px; height: 584px;" onclick="Publish.openArticle(1)"></div>
      `,
      "script": `
      function onPageEnter() {
        setTimeout(function(){
          addContentLinks();
      }, 1000)
      }

      function onPageLeave() {
        removeContentLink();
        Publish.closeArticle();
      }
      `,
      "searchText": "LETTRE DE LA DIRECTRICE EXÉCUTIVE Pendant des mois, le monde entier a retenu son souffle alors que le coronavirus se propageait, évoluait et que nous apprenions à y faire face. Il serait impossible d’éluder dans cette lettre une des pires crises sanitaires que le monde ait jamais connues, une pandémie dont la portée internationale a peu d’équivalents dans l’Histoire de l’humanité. Cependant, il serait profondément injuste de réduire douze mois de travail passionné à cette urgence, aussi inédite soit-elle. On entend souvent dire que la crise du coronavirus a tout changé, mais, dans certains cas, elle n’a fait qu’accentuer des tendances et des faiblesses existantes, tout en braquant les projecteurs sur les défaillances majeures de notre société. Nombre de ces défis sont ceux auxquels Cartier Philanthropy s’engage à répondre dans le cadre de sa mission en finançant des organisations partenaires extrêmement efficaces dont les actions améliorent concrètement les vies des plus vulnérables. L’identification et le financement d’organisations audacieuses et novatrices avec lesquelles établir des alliances à long terme est au cœur de notre action afin d’assurer un impact social maximal. Nous sommes convaincus qu’il est de notre devoir de les servir au mieux afin qu’elles puissent mettre leurs solutions à la disposition du plus grand nombre. Ces organisations ont besoin non seulement que nous fassions preuve de flexibilité et de pragmatisme, mais aussi que nous prêtions une oreille attentive à leurs besoins et leurs difficultés. En d’autres termes, nous travaillons pour elles, pas l’inverse. Notre manière de procéder n’a pas changé quand le coronavirus a frappé et elle ne changera pas une fois que la crise sera terminée. C’est ce que reflètent les divers partenariats que nous avons renouvelés cette année (8) ainsi que les profils des sept organisations qui ont rejoint notre portfolio. Je vous invite à découvrir leur travail remarquable dans le rapport de cette année.  Pascale de la Frégonnière Directrice exécutive  9"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 11-title" style="top:244px; left:186px;" src="/AR2019-20/fr/static/_content/11-title-1.png"> 
      <img class="halfScale 11-sub" style="top:304px; left:359px;" src="/AR2019-20/fr/static/_content/11-sub-1.png"> 
      <div class="abs pointer" style="top: 297px; left: 348px; width: 313px; height: 261px; " onclick="Publish.openArticle(2)"></div>
      <div class="abs pointer" style="top: 239px; left: 178px; width: 506px; height: 39px;" onclick="Publish.openArticle(2)"></div>

      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.fromTo(cOf("11-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("11-sub"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg11Anim.stop();
          removeContentLink()
          Publish.closeArticle();
        }
      `,
      "searchText": "ACCÈS AUX SERVICES DE BASE Chaque jour, même en ces temps incertains et difficiles, des organisations s’engagent pour améliorer l’accès à une éducation de qualité, aux soins de santé primaires, à l’eau potable, à une bonne hygiène et à une alimentation équilibrée. Cependant, le rythme de ces améliorations doit s’accélérer si nous voulons faire en sorte que chaque personne puisse mener une existence saine et épanouissante.  11"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
        <h1 id="12-no1" class="abs brillcutmed 12-no" style="left: 516px; top: 503px; font-size: 2.2em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 38, "append": "%"}'></h1>

      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 581px; height: 46px;" onclick="Publish.openArticle(3)"></div>
      <div class="contentLinkNone abs" style="top: 499px; left: 81px; width: 336px; height: 316px;" onclick="Publish.openArticle(3)"></div>

      
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(cOf("12-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no")[0]);}}, 1)
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg12Anim.stop();
          resetNumbers("12-no");
          removeContentLinks();
          Publish.closeArticle();
        }
      `,
      "searchText": "NOUVEAUX  PROGRAMMES Partenaire : Healthy Learners Pays : Zambie Durée : 2019-2022  Veiller sur la santé des élèves pour leur permettre d’apprendre En Zambie, près de 40 % des enfants en âge d’être scolarisés manquent régulièrement les cours à cause de maladies que l’on peut soigner et éviter, qui affectent leur développement et peuvent entrainer le décrochage scolaire. Healthy Learners aide les écoles à devenir des points d’accès aux soins pour les enfants. Certains professeurs reçoivent une formation d’agent de santé et sont ainsi en mesure de surveiller la santé des élèves, d’évaluer l’état des enfants souffrants, de prodiguer des soins de base et d’envoyer les enfants malades au centre de santé, ainsi que les jeunes filles nécessitant un suivi en santé sexuelle et reproductive.  Nous soutenons les efforts de Healthy Learners pour assurer un accès aux soins à 285 000 enfants fréquentant les écoles primaires publiques des provinces de Lusaka et de Copperbelt d’ici 2022.  12  38%  de réduction de la morbidité"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
        <h1 id="13-no1" class="abs brillcutreg 13-no" style="left: 518px; top: 392px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 98, "append": "%"}'></h1>
        <h1 id="13-no1" class="abs brillcutreg 13-no" style="left: 459px; top: 451px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 77, "append": "%"}'></h1>
        <h1 id="13-no1" class="abs brillcutreg 13-no" style="left: 123px; top: 740px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 1270, "comma": "true"}'></h1>
      
      <div class="contentLinkNone abs" style="top: 99px; left: 64px; width: 366px; height: 351px;" onclick="Publish.openArticle(3)"></div>
      <div class="contentLinkNone abs" style="top: 537px; left: 341px; width: 296px; height: 296px;" onclick="Publish.openArticle(3)"></div>

      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.fromTo(cOf("13-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[0]);}}, 1)
          .fromTo(cOf("13-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[1]);}}, "+=0.2")
          .fromTo(cOf("13-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[2]);}}, "+=0.2")
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg13Anim.stop();
          resetNumbers("13-no");
          removeContentLinks();
          Publish.closeArticle();
        }
      `,
      "searchText": "Priorité à l’éducation secondaire des filles Au Bangladesh et au Cambodge, les préjugés culturels, les discriminations de genre, l’insécurité, le besoin de contribuer aux revenus familiaux et l’injonction à se marier et à créer une famille entravent fortement la réussite scolaire des filles, en particulier dans le secondaire. Le programme d’éducation pour les filles de Room to Read permet aux élèves de poursuivre leur scolarité plus longtemps et d’acquérir au terme de leurs études secondaires les connaissances, les aptitudes et les capacités qui leur permettront de réussir à l’école et dans la vie. Encadré par des femmes de leurs communautés, le programme propose des séances sur les aptitudes à la vie quotidienne, du mentorat individuel et en groupe, un système de soutien social et une prise en charge qui, selon les besoins, inclut les frais scolaires et de transport, les uniformes et la préparation aux examens. Nous soutenons Room to Read afin d’offrir à 4 350 jeunes bangladeshies et cambodgiennes la possibilité de terminer leurs études secondaires et réaliser leur potentiel.  Partenaire : Room to Read Pays : Bangladesh, Cambodge Durée : 2019-2022  98%  En 2018, des élèves qui ont bénéficié du programme au Bangladesh et  77%  des élèves cambodgiennes ont poursuivi des études supérieures.  Lutter contre la malnutrition au Guatemala  Partenaire : Semilla Nueva Pays : Guatemala Durée : 2019-2021  1 270  Plus de sacs de semences ont été vendus en 2018, ce qui signifie que plus de 70 800 personnes ont consommé du maïs enrichi en nutriments pendant un an.  Au Guatemala, les tortillas de maïs sont au menu de chaque repas. Malheureusement, elles sont pauvres en nutriments. Semilla Nueva produit et commercialise des semences de maïs bio-fortifiées, enrichies de manière traditionnelle en protéines de qualité et zinc. Les cultures bio-fortifiées constituent une solution efficace et culturellement adaptée contre la malnutrition chronique au Guatemala puisqu’elles n’altèrent pas le régime alimentaire traditionnel.  À la suite d’une première subvention de trois ans, nous renouvelons notre soutien à Semilla Nueva afin de généraliser la consommation de maïs bio-fortifié et de fournir à 255 000 personnes du maïs plus riche en nutriments. 13"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 586px; height: 46px;" onclick="Publish.openArticle(3)"></div>
      <div class="contentLinkNone abs" style="top: 530px; left: 291px; width: 366px; height: 306px;" onclick="Publish.openArticle(3)"></div>
      <div class="contentLinkNone abs" style="top: 152px; left: 321px; width: 336px; height: 350px;" onclick="Publish.openArticle(3)"></div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          removeContentLinks();
          Publish.closeArticle();
        }
      `,
      "searchText": "NOUVEAUX  PROGRAMMES  Un centre pour les enfants syriens réfugiés au Liban  Partenaire : IECD Pays : Liban Durée : 2019-2023  Le conflit syrien, qui a entraîné des déplacements massifs de population, fait peser une pression considérable sur les pays d’accueil et plus particulièrement sur leurs systèmes éducatifs. Au Liban, malgré les efforts consentis par le ministère de l’Éducation, qui autorise l’inscription gratuite dans les écoles publiques sans exiger de permis de résidence, plus de 300 000 enfants syriens réfugiés restent non scolarisés. Le Centre Janah à Beyrouth accueille les enfants et adolescents issus de familles défavorisées tant syriennes que libanaises. En proposant un soutien scolaire, des activités extrascolaires et un soutien psychosocial, le centre aide les enfants à réintégrer l’école et à réussir leur scolarité.  Notre contribution permettra à 535 enfants et jeunes pendant trois ans de recevoir un soutien scolaire, participer à des activités de développement personnel et bénéficier également d’un transport gratuit et d’un goûter quotidien.  L’eau propre : une affaire de femme Dans le nord du Ghana les populations n’ont pas accès à l’eau Partenaire : Saha Global Pays : Ghana potable. Les villages dépendent du Durée : 2019-2022 ruissellement de l’eau de pluie qui s’accumule dans de grands étangs stagnants. Mais cette eau, boueuse et insalubre, représente un risque important pour leur santé. Saha Global s’efforce d’introduire une technologie de traitement de l’eau simple et abordable dans les communautés les plus pauvres et reculées du pays. Son objectif est de former les femmes dans les villages pour qu’elles puissent établir et maintenir des petites entreprises de traitement de l’eau afin d’approvisionner leurs communautés en eau potable au coût abordable et ainsi générer des revenus. Nous soutenons Saha Global pour mettre en place près de 1 000 nouvelles microentreprises de traitement de l’eau destinées à desservir environ 440 000 personnes d’ici à la fin 2022. 14"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
        <h1 id="15-no1" class="abs brillcutreg 15-no" style="left: 70px; top: 374px; font-size: 1.6em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 93, "append": "%"}'></h1>

        <div class="contentLinkNone abs" style="top: 251px; left: 231px; width: 406px; height: 296px;" onclick="Publish.openArticle(3)"></div>
      <div class="contentLinkNone abs" style="top: 605px; left: 231px; width: 406px; height: 230px;" onclick="Publish.openArticle(3)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim.fromTo(cOf("15-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("15-no")[0]);}}, 1)
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg15Anim.stop();
          resetNumbers("15-no");
          removeContentLinks();
          Publish.closeArticle();
        }
      `,
      "searchText": "Partenaire : Muso Pays : Mali Durée : 2019-2022  La santé n’attend pas Dans les communautés de la périphérie de Bamako, la mortalité des enfants a été réduite de  93% en  trois ans !  Le Mali présente un des plus haut taux de mortalité des enfants de moins de 5 ans dans le monde. Depuis 2008, Muso collabore avec le gouvernement pour transformer la manière dont les soins de santé sont dispensés afin de pouvoir traiter les malades quelques heures après l’apparition des premiers symptômes. Ce «modèle de soins de santé proactifs » consiste à former des agents de santé communautaire qui se rendent dans les villages pour repérer et soigner gratuitement les personnes malades à domicile, ou les mettre en contact avec des cliniques publiques compétentes. Dans les communautés où ce système a été mis en œuvre, la mortalité des enfants a chuté massivement.  Notre soutien va permettre la constitution d’une équipe technique dédiée auprès de gouvernements, décideurs politiques et personnel de santé au Mali et hors de ses frontières pour assurer l’adoption des soins de santé proactifs. Muso envisage de servir 450 000 patients directement et 18 millions de patients indirectement au cours des trois prochaines années.  Partenaire : SOIL Pays : Haïti Durée : 2019-2022  Des toilettes écologiques pour une santé durable  En Haïti, 66 % des habitants des zones urbaines n’ont pas accès à des installations sanitaires et moins de 1 % des excréments sont traités en toute sécurité. Le manque de toilettes a engendré une crise sanitaire publique majeure : Haïti a le taux de diarrhée infantile le plus élevé au monde. Depuis 2006, SOIL travaille dans le pays pour y promouvoir la santé et des moyens de subsistance durables. Grâce à ses installations sanitaires sûres, l’organisation collecte et transforme les excréments en compost à haute valeur agricole. Nous soutenons SOIL avec l’objectif de fournir à 12 000 Haïtiens des installations sanitaires à faible coût qui associent des toilettes sèches à des services de traitement et de transformation des déchets. 15"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
        <h1 id="16-no1" class="abs brillcutreg 16-no" style="left: 88px; top: 523px; font-size: 1.53em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 65700, "comma": "true", "append": " personnes"}'></h1>
        <h1 id="16-no1" class="abs brillcutreg 16-no" style="left: 143px; top: 730px; font-size: 1.53em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 9200, "comma": "true", "append": " personnes"}'></h1>
        <h1 id="16-no1" class="abs brillcutmed 16-no" style="left: 459px; top: 683px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 51, "append": "%"}'></h1>
        <h1 id="16-no1" class="abs brillcutmed 16-no" style="left: 453px; top: 738px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 89, "append": "%"}'></h1>

        <div class="contentLinkNone abs" style="top: 82px; left: 84px; width: 278px; height: 746px;" onclick="Publish.openArticle(4)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim.fromTo(cOf("16-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[0]);}}, 1)
          .fromTo(cOf("16-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[1]);}}, "+=0.2")
          .fromTo(cOf("16-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[2]);}}, "+=0.2")
          .fromTo(cOf("16-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[3]);}}, "+=0.2")
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg16Anim.stop();
          resetNumbers("16-no");
          removeContentLinks();
          Publish.closeArticle();
        }
      `,
      "searchText": "RÉSULTATS Prévenir le choléra dans les communautés de pêcheurs de l’Ouganda Le choléra est endémique sur les rives du lac Albert. La pêche constitue la principale activité économique de la région et l’accès à l’eau et à l’assainissement est extrêmement limité. Nous avons soutenu la Croix-Rouge pour améliorer durablement les conditions de vie et l’état de santé de 10 000 habitants du rift Albertin, au nord-ouest de l’Ouganda, en portant une attention particulière à l’adoption de bonnes pratiques d’hygiène, à l’approvisionnement en eau potable et à l’installation de sanitaires adéquats. Des agents de santé bénévoles de la Croix-Rouge ont sensibilisé à l’hygiène plus de  65 700 personnes,  entraînant une hausse de 38 % de la construction et de l’utilisation de latrines privées, de sanitaires, de séchoirs, de points de lavage des mains et de fosses à déchets.  Partenaire : FICR Pays : Ouganda Durée : 2017-2019  La couverture en installations sanitaires des centres de santé et des écoles de la région a été fortement améliorée.  De  51%  9 200 personnes  Plus de ont pu accéder à de l’eau potable grâce à la construction et réhabilitation de 8 puits et l’ajout de 6 kilomètres de conduites au système d’alimentation en eau. 16  à  89%"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
        <h1 id="17-no1" class="abs brillcutreg 17-no" style="left: 70px; top: 298px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 160, "comma": "true"}'></h1>
        <h1 id="17-no1" class="abs brillcutreg 17-no" style="left: 70px; top: 407px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 1558, "comma": "true"}'></h1>
        <h1 id="17-no1" class="abs brillcutreg 17-no" style="left: 346px; top: 361px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 37500, "comma": "true"}'></h1>
        <h1 id="17-no1" class="abs brillcutreg 17-no" style="left: 70px; top: 758px; font-size: 1.56em; font-weight:400; margin:0; color:#C9252C; padding:0; margin:0;"  data-number='{"to": 80, "comma": "true", "append": "%"}'></h1>
        <div class="contentLinkNone abs" style="top: 102px; left: 344px; width: 298px; height: 352px;" onclick="Publish.openArticle(4)"></div>
        <div class="contentLinkNone abs" style="top: 300px; left: 64px; width: 258px; height: 201px;" onclick="Publish.openArticle(4)"></div>
        <div class="contentLinkNone abs" style="top: 510px; left: 64px; width: 480px; height: 181px;" onclick="Publish.openArticle(4)"></div>
        <div class="contentLinkNone abs" style="top: 636px; left: 544px; width: 58px; height: 55px;" onclick="Publish.openArticle(4)"></div>
        <div class="contentLinkNone abs" style="top: 691px; left: 64px; width: 228px; height: 29px;" onclick="Publish.openArticle(4)"></div>

      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim.fromTo(cOf("17-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[0]);}}, 1)
          .fromTo(cOf("17-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[1]);}}, "+=0.2")
          .fromTo(cOf("17-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[2]);}}, "+=0.2")
          .fromTo(cOf("17-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[3]);}}, "+=0.2")
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg17Anim.stop();
          resetNumbers("17-no");
          removeContentLinks();
          Publish.closeArticle();

        }
      `,
      "searchText": "Surmonter les distances pour améliorer la santé des enfants  160  missions de dépistage ont été organisées dans les écoles et les centres de santé pour la détection précoce et le traitement des maladies infantiles les plus communes  1 558  enfants ont reçu un suivi médical gratuit et de qualité dans le cadre de 9 camps de chirurgie et 12 mini-camps de consultations spécialisées.  Au Sénégal, la concentration des médecins généralistes Partenaire : Amref Pays : Sénégal et des spécialistes dans Durée : 2016-2019 les hôpitaux de la capitale entraîne une grande disparité entre les services médicaux et chirurgicaux disponibles à Dakar et dans les zones reculées du Sud. En cinq ans, l’Amref est parvenu à renforcer l’accès aux soins préventifs essentiels ainsi qu’aux soins spécialisés pour plus de 35 000 enfants dans 60 écoles primaires et plus de 50 postes de santé de Kolda et de Sédhiou.  37 500  femmes en âge de procréer ont renforcé leurs connaissances et leurs compétences en matière de santé reproductive, santé des enfants, hygiène et nutrition.  Nous poursuivons notre  Réduire l’abandon scolaire à Madagascar  soutien  Le niveau d’instruction à Madagascar compte parmi les pour trois ans plus bas du monde ; les enfants y sont scolarisés en moyenne pendant quatre ans seulement. Dans les communautés rurales, tout juste 19 % des enfants poursuivent des études secondaires et ils ne sont que 1 % à obtenir leur baccalauréat. Depuis 2006, l’IECD et l’association malgache PROMES collaborent pour réduire le décrochage scolaire dans les communautés rurales en créant des centres de soutien qui proposent un accompagnement individuel scolaire et extrascolaire des élèves. Nous avons financé trois centres dans la région de Fianarantsoa pour soutenir 360 élèves pendant trois ans. Partenaire : IECD Pays : Madagascar Durée : 2017-2019  80%  ont réussi l’examen du BEPC alors que le taux de réussite moyen national s’élève à 53 %. 17"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 256px; left: 86px; width: 573px; height: 161px;" onclick="Publish.openArticle(5)"></div>
      <div class="contentLinkNone abs" style="top: 516px; left: 86px; width: 573px; height: 146px;" onclick="Publish.openArticle(5)"></div>
      
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
        removeContentLinks();
        Publish.closeArticle();
        }
      `,
      "searchText": "LIVING GOODS Kenya – 2018-2020 270 agents de santé communautaire prodiguent des soins de qualité à domicile à plus de 220 000 personnes à l’ouest du Kenya.  WATER AND SANITATION FOR THE URBAN POOR Madagascar – 2017-2020 WSUP collabore avec la compagnie nationale des eaux et les communautés locales pour concevoir des services d’approvisionnement en eau et d’assainissement desservant plus de 60 000 habitants des bidonvilles urbains de Tananarive.  PROGRAMMES EN PROGRAMME ALIMENTAIRE MONDIAL  FICR Myanmar, Cambodge – 2017-2020 La Croix-Rouge collabore avec des communautés locales pour assurer à 36 000 personnes l’accès à l’eau potable, et à 39 000 l’accès à des installations sanitaires adaptées et à de bonnes pratiques d’hygiène.  COURS  Mozambique – 2017-2020  PROGRAMME ALIMENTAIRE MONDIAL  2 000 petits agriculteurs produisant du maïs, des haricots et des légumes frais pour les repas scolaires découvrent des solutions simples et abordables qui leur permettent de réduire leurs pertes post-récolte et d’augmenter leurs revenus.  Burkina Faso – 2014-2020  PROGRAMME ALIMENTAIRE MONDIAL  Une chaîne d’approvisionnement en produits laitiers dirigée par des femmes relie les petits éleveurs et les producteurs locaux à 71 cantines scolaires où 12 500 élèves reçoivent du yaourt frais pour leur collation du matin.  6 000 enfants reçoivent chaque jour des repas scolaires grâce à l’initiative «Healthy Kitchen» qui fournit un emploi à 30 réfugiés syriens et jordaniens en situation précaire.  18  Jordanie – 2018-2021"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 133px; left: 86px; width: 203px; height: 684px;" onclick="Publish.openArticle(5)"></div>
      `,
      "script": `
      function onPageEnter() {
        setTimeout(function(){
          addContentLinks();
        }, 1000);
      }

      function onPageLeave() {
      removeContentLinks();
      Publish.closeArticle();

      }
      `,
      "searchText": "EDUCATE GIRLS Inde – 2014-2020 Educate Girls stimule la scolarisation des filles, promeut des infrastructures éducatives adaptées et améliore les résultats scolaires de 100 000 enfants dans 1 053 villages du district de Rajsamand.  SANTÉ INTÉGRÉE Togo – 2019-2021 Santé Intégrée a créé un modèle communautaire abordable permettant d’assurer à 240 000 togolais l’accès aux soins de santé primaires de qualité.  VISIONSPRING Bangladesh – 2018-2021 VisionSpring s’est associé à BRAC au Bangladesh pour fournir des lunettes résistantes, esthétiques et abordables à plus de 600 000 personnes à faible revenu.  LUMINOS FUND Éthiopie – 2018-2021 10 000 enfants éthiopiens vivant dans les régions reculées d’Afar et d’Oromiya réintégreront l’enseignement public au terme d’un programme d’apprentissage intensif de 10 mois.  19"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 21-title" style="top:244px; left:146px;" src="/AR2019-20/fr/static/_content/21-title-1.png">
      <img class="halfScale 21-sub" style="top:374px; left:367px;" src="/AR2019-20/fr/static/_content/21-sub-1.png">
      <div class="pointer abs" style="top: 239px; left: 138px; width: 546px; height: 37px;" onclick="Publish.openArticle(6)"></div>
      <div class="pointer abs" style="top: 277px; left: 358px; width: 279px; height: 67px;" onclick="Publish.openArticle(6)"></div>
      <div class="pointer abs" style="top: 371px; left: 358px; width: 291px; height: 402px;" onclick="Publish.openArticle(6)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim.fromTo(cOf("21-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          pg21Anim.fromTo(cOf("21-sub"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
        }

        function onPageLeave() {
          pg21Anim.stop();
        removeContentLinks();
        Publish.closeArticle();

        }
      `,
      "searchText": "DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES Les inégalités de genre ne sont pas seulement le produit de normes sociales discriminatoires, de déséquilibres de pouvoir et d’obstacles juridiques. Elles racontent aussi — et surtout — l’histoire des partis pris et des préjugés à l’encontre des femmes, portés par les hommes comme par les femmes, une histoire qui se répète encore et encore. Pour démanteler les inégalités structurelles, nous devons agir à plusieurs niveaux et dans divers contextes — dans les foyers, les écoles, sur les lieux de travail et dans la fonction publique — en soutenant les femmes et les filles dans leur lutte pour l’obtention de places qui leur reviennent de plein droit."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
      <h1 id="22-no1" class="abs brillcutreg 22-no" style="left: 511px; top: 326px; font-size: 1.56em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;"  data-number='{"to": 1400, "append":"%", "preppend":"+ ", "comma": "true"}'></h1>
      <h1 id="22-no1" class="abs brillcutreg 22-no" style="left: 511px; top: 375px; font-size: 1.56em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;"  data-number='{"to": 258, "append":"%", "preppend":"+ ", "comma": "true"}'></h1>
      <h1 id="22-no1" class="abs brillcutreg 22-no" style="left: 510px; top: 442px; font-size: 1.56em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;"  data-number='{"to": 147, "append":"%", "preppend":"+ ", "comma": "true"}'></h1>

      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 577px; height: 46px;" onclick="Publish.openArticle(7)"></div>
      <div class="contentLinkNone abs" style="top: 152px; left: 81px; width: 402px; height: 354px;" onclick="Publish.openArticle(7)"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim.fromTo(cOf("22-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[0]);}}, 1)
          .fromTo(cOf("22-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[1]);}}, "+=0.2")
          .fromTo(cOf("22-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[2]);}}, "+=0.2")
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers("22-no");
        removeContentLinks();
        Publish.closeArticle();

        }
      `,
      "searchText": "NOUVEAUX Partenaire : BOMA Project Pays : Kenya Durée : 2019-2021  PROGRAMMES  Combattre la pauvreté dans les zones arides d’Afrique  Dans les régions arides et semi-arides du nord du Kenya, des familles d’éleveurs vivent sans eau courante ni électricité, à des kilomètres des commerces, des routes asphaltées, des transports publics, des écoles et des centres de santé les plus proches. Le bétail constitue leur source principale de revenus. Des mois durant, les hommes voyagent loin avec leurs troupeaux à la recherche d’eau et de pâturage, deux ressources rares. Les femmes restent au village, prisonnières d’une pauvreté extrême et d’une insécurité alimentaire chronique. Avec des interventions séquencées qui incluent des formations pour développer des compétences et des connaissances, BOMA Project permet aux femmes les plus pauvres de créer des entreprises et des groupes d’épargne, de renforcer la sécurité financière et alimentaire de leur foyer, d’investir dans la santé et l’éducation de leurs enfants, et d’imposer un peu plus leur voix. Nous soutenons BOMA Project pour permettre à 500 000 femmes et enfants d’améliorer leurs conditions de vie.  22  L’impact de BOMA Project est décisif :  + 1 400%  d’économies  + 258% de  dépenses médicales annuelles  + 147%  de revenus des ménages"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      <h1 id="23-no1" class="abs brillcutmed 23-no" style="left: 548px; top: 426px; font-size: 2.1em; font-weight:400; margin:0; color:#40bacb; padding:0; margin:0;"  data-number='{"to": 8830, "comma": "true"}'></h1>

      <div class="contentLinkNone abs" style="top: 102px; left: 351px; width: 286px; height: 280px;" onclick="Publish.openArticle(7)"></div>
      <div class="contentLinkNone abs" style="top: 376px; left: 351px; width: 171px; height: 103px;" onclick="Publish.openArticle(7)"></div>
      <div class="contentLinkNone abs" style="top: 492px; left: 61px; width: 332px; height: 346px;" onclick="Publish.openArticle(7)"></div>

      `,
      "script": `
      function onPageEnter() {
        pg23Anim = new TimelineMax();
        pg23Anim.fromTo(cOf("23-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[0]);}}, 1)
        setTimeout(function(){
          addContentLinks();
        }, 1000);
      }

      function onPageLeave() {
        pg23Anim.stop();
        resetNumbers("23-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "Provoquer le changement social en Afrique de l’Ouest Le modèle collaboratif de Tostan favorise le changement social et l’évolution des comportements en engageant un dialogue intra et intercommunautaire approfondi pour sensibiliser jeunes, femmes, hommes, anciens et chefs religieux aux droits humains, à la santé, à l’hygiène, à la résolution de conflit, à l’autonomie économique et au rôle de parent. Ce travail a abouti à l’un des résultats les plus notoires à ce jour : des milliers de communautés ont déclaré publiquement avoir abandonné le mariage précoce et la pratique de l’excision. Partenaire : Tostan Pays : Gambie, Guinée-Bissau, Sénégal Durée : 2019-2023  Après avoir soutenu Tostan dans le sud-est du Sénégal de 2016 à 2018, nous contribuons à une initiative conjointe dans trois pays pour toucher plus de 107 500 personnes au sein de 1 300 communautés reculées en Gambie, en Guinée-Bissau et au Sénégal. communautés !  8 830  Place aux femmes dans le secteur de la construction En Afrique de l’Est, le secteur de la construction connaît une très forte croissance, mais est aussi l’un des plus affectés par le manque de main-d’œuvre qualifiée. Le programme pilote de Buildher forme des jeunes femmes défavorisées des bidonvilles de Nairobi, en les aidant à acquérir des compétences très recherchées dans ce domaine, ainsi qu’à obtenir un certificat professionnel reconnu qui leur donnera de meilleures chances de trouver un emploi stable et d’être économiquement indépendantes. En permettant à des femmes qualifiées d’intégrer le secteur de la construction, dominé par les hommes, Buildher contribue à bousculer les attitudes culturelles autour du caractère « genré » de certains secteurs d’emploi au Kenya. Partenaire : Buildher Pays : Kenya Durée : 2019-2021  Nous soutenons Buildher pour former 400 jeunes femmes, dont au moins 320 accèderont à un emploi rémunéré. 23"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      <h1 id="24-no1" class="abs brillcutmed 24-no" style="left: 559px; top: 532px; font-size: 2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 40, "append": "% à"}'></h1>
      <h1 id="24-no1" class="abs brillcutmed 24-no" style="left: 567px; top: 563px; font-size: 2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 1.3, "decimals": 1, "append": "%!"}'></h1>

      <img class="halfScale 24-text" style="top:510px; left:89px;" src="/AR2019-20/fr/static/_content/24-text-2.png">        
      <img class="halfScale 24-text" style="top:707px; left:312px;" src="/AR2019-20/fr/static/_content/24-text-3.png">        


      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 366px; height: 46px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 136px; left: 302px; width: 236px; height: 46px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 199px; left: 311px; width: 336px; height: 251px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 451px; left: 311px; width: 220px; height: 47px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 505px; left: 84px; width: 444px; height: 117px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 622px; left: 84px; width: 554px; height: 77px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 701px; left: 309px; width: 367px; height: 137px;" onclick="Publish.openArticle(8)"></div>

      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
          pg24Anim.staggerFromTo(cOf("24-text"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)
          .fromTo(cOf("24-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[0]);}}, "+=0.3")
          .fromTo(cOf("24-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[1]);}}, "+=0.2")
        }

        function onPageLeave() {
          pg24Anim.stop();
          resetNumbers("24-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "RÉSULTATS ET SUIVI Partenaire : mothers2mothers Pays : Ouganda Durée : 2017-2019 > 2020-2023  Généraliser le modèle des Mères Mentors en Ouganda mothers2mothers forme et emploie des mères séropositives en tant qu’agents de santé de première ligne. Ces Mères Mentors interviennent dans les communautés les plus défavorisées. Elles travaillent à la fois dans des centres de santé et au sein de leurs communautés pour prodiguer des soins aux femmes, aux enfants, aux adolescents et aux familles toutes entières. Elles facilitent l’accès aux soins, améliorent le maintien des patients dans le système de santé et assurent l’adhérence au traitement en concentrant leurs efforts sur la réduction des infections au VIH et aux maladies associées. Des éducatrices adolescentes travaillent aussi dans les mêmes communautés que les Mères Mentors pour sensibiliser en particulier les adolescentes et les jeunes femmes aux services de santé sexuelle Le taux de et reproductive. transmission Entre 2017 et 2019, nous avons soutenu mothers2mothers pour développer son modèle de Mères Mentors dans sept centres de santé et dans les communautés environnantes du centre-est de l’Ouganda.  82 Mères Mentors et 36 éducatrices adolescentes sont intervenues auprès de 77 000 femmes et adolescentes, principalement des femmes enceintes ou allaitantes.  du VIH de la mère à son bébé diminue de  40% à 1,3%!  Les Mères Mentors ont saisi toutes les opportunités au sein de leurs communautés pour sensibiliser les familles, les informer et les encourager à faire un test de dépistage du VIH. Grâce à leur implication, 2 771 100 267 personnes.  2020-2023 Pour atteindre 167 000 personnes dès la première année!  sessions de sensibilisation ont permis d’informer Afin d’accroitre les progrès réalisés grâce à notre premier financement, nous renouvelons notre soutien pour renforcer l’impact du modèle de Mères Mentors dans le centre-est de l’Ouganda. mothers2mothers pourra ainsi diversifier les soins proposés et agir dans les domaines de la santé maternelle et infantile, de l’apprentissage précoce, du handicap, ou encore de la santé reproductive des adolescentes. 24"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
      <h1 id="25-no1" class="abs brillcutmed 25-no" style="left: 485px; top: 713px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 76.5, "append": "%", "decimals": 1}'></h1>
      <img class="halfScale 25-text" style="top:541px; left:70px;" src="/AR2019-20/fr/static/_content/25-text-2.png">        
      <img class="halfScale 25-text" style="top:707px; left:71px;" src="/AR2019-20/fr/static/_content/25-text-3.png">        
      <div class="contentLinkNone abs" style="top: 205px; left: 66px; width: 336px; height: 315px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 532px; left: 66px; width: 606px; height: 112px;" onclick="Publish.openArticle(8)"></div>
      <div class="contentLinkNone abs" style="top: 701px; left: 64px; width: 334px; height: 137px;" onclick="Publish.openArticle(8)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim.staggerFromTo(cOf("25-text"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)
          .fromTo(cOf("25-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("25-no")[0]);}}, "+=0.3")
        }

        function onPageLeave() {
          pg25Anim.stop();
          resetNumbers("25-no");
        removeContentLinks();
        Publish.closeArticle();

      }
      `,
      "searchText": "Partenaire : StrongMinds Pays : Zambie Durée : 2018-2019 > 2020-2023  Soigner les femmes souffrant de dépression en Zambie La dépression est l’une des maladies les plus négligées dans les pays en voie de développement. En raison du manque d’attention prêtée aux troubles mentaux et des préjugés tenaces qui y sont attachés, rares sont celles et ceux qui peuvent reconnaître leurs symptômes et bénéficier d’une prise en charge. En outre, les services de santé mentale font cruellement défaut dans ces régions. En Ouganda, StrongMinds forme des animateurs en santé mentale chargés d’encadrer des groupes de parole : un modèle unique, simple et éprouvé pour soigner les femmes souffrant de dépression au sein de communautés défavorisées. Au terme de leur thérapie de groupe, 80 % des femmes ne souffrent plus de dépression. Entre 2018 et 2019, nous avons soutenu StrongMinds afin de constituer une équipe pour répliquer le modèle de l’Ouganda en Zambie. Les résultats sont très encourageants :  1 460 femmes vivant à Misisi, un des plus grands bidonvilles de Zambie, ont suivi la thérapie avec succès, ce qui représente 20 % de plus que l’objectif initial. Avec le soutien des nouveaux animateurs en santé mentale, ces femmes ont appris à reconnaître les déclencheurs et les symptômes de la dépression. Une fois les symptômes dépressifs neutralisés, les participantes se nourrissent mieux, présentent une meilleure forme physique et prennent mieux soin de leurs enfants.  2020-2023 StrongMinds est aujourd’hui en passe de devenir conseiller technique en santé mentale auprès du ministère zambien de la Santé. Au cours des trois prochaines années, StrongMinds compte développer son modèle à travers des partenariats et l’intégrer progressivement au système national de santé. L’objectif est de soigner plus de 8 000 femmes. 25  Au terme de la thérapie,  76,5% sont parvenues à vaincre la dépression"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
      <h1 id="26-no1" class="abs brillcutmed 26-no" style="left: 539px; top: 367px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 200, "append": ""}'></h1>
      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 306px; height: 46px;" onclick="Publish.openArticle(9)"></div>
      <div class="contentLinkNone abs" style="top: 154px; left: 82px; width: 378px; height: 334px;" onclick="Publish.openArticle(9)"></div>
      <div class="contentLinkNone abs" style="top: 610px; left: 334px; width: 324px; height: 227px;" onclick="Publish.openArticle(9)"></div>
      <div class="contentLinkNone abs" style="top: 699px; left: 79px; width: 264px; height: 137px;" onclick="Publish.openArticle(9)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim.fromTo(cOf("26-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[0]);}}, 1)
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg26Anim.stop();
          resetNumbers("26-no");
        removeContentLinks();
        Publish.closeArticle();

      }
      `,
      "searchText": "RÉSULTATS Des taxis conduits par des femmes pour les femmes Azad Foundation s’attaque aux barrières culturelles et socioéconomiques en Inde afin d’ouvrir aux femmes marginalisées l’accès à des métiers non traditionnels. Son programme « Women on Wheels » s’adresse aux femmes vulnérables issues de milieux défavorisés en leur offrant une formation de chauffeur professionnel. En plus de l’apprentissage essentiel de la conduite, cette formation couvre des domaines tels que les droits, l’autodéfense, l’anglais, la présentation personnelle, l’hygiène et l’éducation financière. Entre 2017 et 2020 nous avons soutenu Azad pour identifier et former des femmes vulnérables issues des quartiers les plus pauvres de Jaipur. Diverses activités ont eu lieu au sein de 225 bidonvilles pour sensibiliser les communautés aux questions d’égalité de genre. 11 346 femmes ont été exposées à ces sessions de mobilisation. Partenaire : Azad Foundation Pays : Inde Durée : 2017-2020  Plus de  200  ont validé la formation  Partenaire : Swiss Academy for Development Pays : Myanmar Durée : 2017-2019  Dépasser le traumatisme  Pendant 350 sessions, 800 participants ont appris à reconnaître les signes d’un traumatisme et ses effets sur leurs vies. Un soutien financier a été accordé à 28 petites activités commerciales et 8 groupes d’épargne et de crédit.  Le Myanmar a été le théâtre de l’une des guerres civiles les plus longues que le monde ait connu. Les femmes et les enfants en ont été les premières victimes. Ils souffrent aujourd’hui des conséquences psychologiques de ce traumatisme et vivent dans un climat de violence latente et de peur où silence et impunité règnent en maîtres. Dans sept villages de Taungû, Swiss Academy for Development et Karen Women Empowerment Group ont permis à des femmes et des jeunes de surmonter leur traumatisme et faire face à leur détresse mentale à travers l’activité physique, la danse et le jeu de rôle. 26"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
      <h1 id="27-no1" class="abs brillcutmed 27-no" style="left: 154px; top: 784px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 82, "append": "%"}'></h1>

      <div class="contentLinkNone abs" style="top: 102px; left: 71px; width: 196px; height: 76px;" onclick="Publish.openArticle(9)"></div>
      <div class="contentLinkNone abs" style="top: 397px; left: 68px; width: 226px; height: 314px;" onclick="Publish.openArticle(9)"></div>
      <div class="contentLinkNone abs" style="top: 112px; left: 331px; width: 196px; height: 139px;" onclick="Publish.openArticle(10)"></div>
      <div class="contentLinkNone abs" style="top: 279px; left: 331px; width: 196px; height: 139px;" onclick="Publish.openArticle(10)"></div>
      <div class="contentLinkNone abs" style="top: 417px; left: 331px; width: 196px; height: 163px;" onclick="Publish.openArticle(10)"></div>
      <div class="contentLinkNone abs" style="top: 509px; left: 331px; width: 196px; height: 197px;" onclick="Publish.openArticle(10)"></div>
      <div class="contentLinkNone abs" style="top: 709px; left: 331px; width: 196px; height: 163px;" onclick="Publish.openArticle(10)"></div>

      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim.fromTo(cOf("27-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("27-no")[0]);}}, 1)
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg27Anim.stop();
          resetNumbers("27-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "Apporter de l’espoir aux femmes entrepreneurs  ASIAN UNIVERSITY FOR WOMEN  Partenaire : CREA Pays : Mexique Durée : 2016-2019  20 jeunes femmes de milieux très défavorisés d’Asie reçoivent une bourse d’étude qui leur permettra d’obtenir un diplôme universitaire et de se faire une place dans les sociétés patriarcales de leur pays.  Bangladesh – 2018−2023  WOMEN FOR WOMEN INT. Kosovo et Rwanda 2017-2020  CREA aide des femmes à développer leurs microentreprises à travers des formations, du mentorat et l’accès à certains services qui leur permettent d’améliorer leurs méthodes de production et de distribution et de trouver de nouveaux débouchés commerciaux. Ce programme de développement commercial a été proposé dans les centres de formation de CREA à Hidalgo, Querétaro, Yucatán, Guerrero et Toluca. Plus de 7 760 femmes ont acquis des nouvelles compétences et ont accédé à de nouvelles sources de financement. Leurs entreprises ont réalisé une augmentation de 10% de leurs profits hebdomadaires.  Taux de survie de  82%  1 350 femmes participent à un programme complet d’émancipation d’une année qui leur permet de sortir de la pauvreté et de l’isolement pour atteindre une autonomie économique et sociale.  PROGRAMMES  EN COURS INTERNATIONAL CENTER FOR RESEARCH ON WOMEN Rwanda et Tanzanie 2019−2014 Une étude de terrain est en cours pour tester des stratégies d’engagement des hommes en les intégrant aux programmes traditionnels de soutien économique et social des femmes. Women for Women Int. au Rwanda et Hand in Hand Int. en Tanzanie dirigent ces programmes auxquels 900 femmes et 470 hommes participent.  MARIE STOPES INT. Sénégal – 2019−2021 Une équipe mobile offre des services de santé sexuelle et reproductive réguliers et gratuits à 12 000 jeunes filles et femmes du nord-ouest du Sénégal. 27"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 29-title" style="top:249px; left:126px;" src="/AR2019-20/fr/static/_content/29-title-1.png">        
      <img class="halfScale 29-sub" style="top:374px; left:367px;" src="/AR2019-20/fr/static/_content/29-sub-1.png">        
      <div class="pointer abs" style="top: 239px; left: 60px; width: 546px; height: 37px;" onclick="Publish.openArticle(11)"></div>
      <div class="pointer abs" style="top: 277px; left: 358px; width: 296px; height: 37px;" onclick="Publish.openArticle(11)"></div>
      <div class="pointer abs" style="top: 310px; left: 358px; width: 186px; height: 37px;" onclick="Publish.openArticle(11)"></div>
      <div class="pointer abs" style="top: 370px; left: 358px; width: 283px; height: 361px;" onclick="Publish.openArticle(11)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim.fromTo(cOf("29-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("29-sub"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, "-=0.3")
          setTimeout(function(){
            addContentLinks();
          }, 1900);
        }

        function onPageLeave() {
          pg29Anim.stop();
        removeContentLinks();
        Publish.closeArticle();

        }
      `,
      "searchText": "MODES DE SUBS ISTANCE ET ÉCOSYSTÈMES DURABLES Deux tiers des personnes les plus pauvres au monde vivent en zone rurale et souffrent d’un manque d’accès aux marchés, à l’éducation, à des infrastructures de qualité, aux perspectives d’emploi, aux soins médicaux et aux produits financiers. Pour éradiquer l’extrême pauvreté — et la limiter à moins de 3 % de la population mondiale — nous devons en priorité soutenir les petits fermiers partout dans le monde grâce à des modèles éprouvés qui leur permettent d’acquérir les compétences nécessaires, un salaire décent, une sécurité financière afin d’améliorer leur qualité de vie."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
      <h1 id="30-no1" class="abs brillcutreg 30-no" style="left: 564px; top: 529px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;"  data-number='{"to": 8250, "comma": "true"}'></h1>
      <h1 id="30-no1" class="abs brillcutmed 30-no" style="left: 523px; top: 755px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 56.7, "decimals": 1, "append": "%"}'></h1>

      <img class="halfScale 30-text" style="top:478px; left:88px;" src="/AR2019-20/fr/static/_content/30-text-2.png">        
      <img class="halfScale 30-text" style="top:740px; left:88px;" src="/AR2019-20/fr/static/_content/30-text-3.png">        

      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 366px; height: 46px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 136px; left: 321px; width: 326px; height: 46px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 224px; left: 83px; width: 326px; height: 231px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 470px; left: 84px; width: 526px; height: 51px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 520px; left: 84px; width: 464px; height: 87px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 607px; left: 84px; width: 574px; height: 57px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 730px; left: 83px; width: 407px; height: 117px;" onclick="Publish.openArticle(12)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg30Anim = new TimelineMax();
          pg30Anim.staggerFromTo(cOf("30-text"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)
          .fromTo(cOf("30-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("30-no")[0]);}}, 1)
          .fromTo(cOf("30-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("30-no")[1]);}}, "+=0.2")
        }

        function onPageLeave() {
          pg30Anim.stop();
          resetNumbers("30-no");
        removeContentLinks();
        Publish.closeArticle();

      }
      `,
      "searchText": "RÉSULTATS ET SUIVI Partenaire : BRAC Pays : Ouganda Durée : 2017-2019 > 2019-2022  Handicap et extrême pauvreté en Ouganda Les causes de la pauvreté sont multiples, c’est pourquoi le programme de formation des personnes les plus pauvres de BRAC s’attaque au problème sur plusieurs fronts. Il fournit aux plus démunis des moyens de production, un soutien financier temporaire pour leur consommation journalière, un accompagnement à la création d’entreprise, des plans d’épargne et un coaching aux aptitudes de vie, ainsi qu’un accès gratuit aux soins. En associant encadrement, transfert de connaissances et de compétences ce programme de 24 mois aide les individus et leurs familles à sortir de l’extrême pauvreté. Entre 2016 et 2019, nous avons soutenu l’adaptation de ce programme en Ouganda, dans les districts extrêmement défavorisés de Luwero et Kiryandongo.  1 650 jeunes parmi les plus démunis ne sont plus en situation de pauvreté extrême et disposent de moyens de subsistance pérennes. Ils ont amélioré objectivement leurs revenus, leur consommation, leurs moyens de production, leur sécurité alimentaire et leur santé, et ont fait de même pour leurs familles.  8 250  personnes au total  Le programme est axé sur l’incitation à l’épargne chez les jeunes. La formation financière donne aux participants les connaissances et les outils nécessaires pour gérer leur argent et planifier leur avenir : 100 associations villageoises d’épargne et de crédit ont été mises sur pied.  2019-2022 Nous maintenons notre soutien à BRAC en Ouganda, où l’organisation mène un projet pilote de formation à destination des plus démunis adapté aux personnes handicapées en partenariat avec Handicap International et la National Union of Women with Disabilities of Uganda. Ensemble, ils devraient permettre à 2 700  personnes et leurs familles de sortir de la pauvreté. 30  Les montants épargnés ont augmenté de  56,7%"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
      <h1 id="31-no1" class="abs brillcutmed 31-no" style="left: 540px; top: 375px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 55, "append": "%"}'></h1>
      <h1 id="31-no1" class="abs brillcutmed 31-no" style="left: 93px; top: 727px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 311, "append": "%"}'></h1>

      <img class="halfScale 31-text" style="top:634px; left:71px;" src="/AR2019-20/fr/static/_content/31-text-2.png">        
      <img class="halfScale 31-text" style="top:757px; left:239px;" src="/AR2019-20/fr/static/_content/31-text-3.png">        

      <div class="contentLinkNone abs" style="top: 476px; left: 67px; width: 396px; height: 25px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 502px; left: 68px; width: 570px; height: 184px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 750px; left: 233px; width: 394px; height: 97px;" onclick="Publish.openArticle(12)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim.staggerFromTo(cOf("31-text"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)
          .fromTo(cOf("31-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[0]);}}, "+=0.3")
          .fromTo(cOf("31-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[1]);}}, "+=0.2")
        }

        function onPageLeave() {
          pg31Anim.stop();
          resetNumbers("31-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "Partenaire : Village Enterprise Pays : Ouganda Durée : 2016-2019 > 2020-2023  55%  ont augmenté leur valeur  Tracer la voie pour sortir de la pauvreté Le programme de formation à la création de microentreprises de Village Enterprise a déjà démontré son efficacité : il permet de sortir les personnes de la pauvreté extrême en les aidant à développer des moyens de subsistance durables. Les participants, identifiés suite à un classement socio-économique participatif, bénéficient d’une aide financière, de formations en entrepreneuriat et finance, et d’un mentorat continu avec un entrepreneur local. Ils reçoivent aussi un soutien à la création de petites activités commerciales et à la formation de groupes d’épargne et de crédit. Entre 2016 et 2019, 900 entreprises de trois personnes ont été créées, ainsi que 90 groupes d’épargne, ce qui a permis à 2 700 personnes d’accéder à l’autonomie sociale et économique.  311%  d’augmentation de l’épargne des foyers  2020-2023 Nous renouvelons notre soutien à Village Enterprise en Ouganda avec l’objectif de fournir à 2 700 personnes parmi les plus démunies, principalement des femmes, les connaissances, les compétences et la confiance nécessaires pour développer des microentreprises durables. 31"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
      <h1 id="32-no1" class="abs brillcutreg 32-no" style="left: 88px; top: 364px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;"  data-number='{"to": 50, "append": "%"}'></h1>
      <h1 id="32-no1" class="abs brillcutmed 32-no" style="left: 572px; top: 488px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 3, "preppend": "1/"}'></h1>
      <img class="halfScale 32-text" style="top:338px; left:225px;" src="/AR2019-20/fr/static/_content/32-text-2.png">        
      <img class="halfScale 32-text" style="top:520px; left:89px;" src="/AR2019-20/fr/static/_content/32-text-3.png">        
      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 366px; height: 46px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 136px; left: 321px; width: 326px; height: 46px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 224px; left: 83px; width: 576px; height: 93px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 333px; left: 217px; width: 436px; height: 144px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 518px; left: 84px; width: 366px; height: 65px;" onclick="Publish.openArticle(12)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim.staggerFromTo(cOf("32-text"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)
          .fromTo(cOf("32-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[0]);}}, 1)
          .fromTo(cOf("32-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[1]);}}, "+=0.2")
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "RÉSULTATS ET SUIVI Partenaire : One Acre Fund Pays : Rwanda Durée : 2016-2019 > 2020-2023  Des agriculteurs prospères, des communautés dynamiques Le dynamisme des communautés rurales repose sur des petits agriculteurs solides. One Acre Fund propose aux fermiers d’Afrique de l’Est un ensemble de services, dont des semences et engrais améliorés, des financements ainsi que des formations et un accès au marché. Ces services les aident à augmenter leurs rendements sur une saison et, donc, leur qualité de vie. Près de  50%  de femmes  Entre 2016 et 2019, les actions de One Acre Fund ont permis à  390 000 fermiers rwandais d’augmenter leurs revenus de 120 dollars en moyenne par an, améliorant ainsi la qualité de vie de plus de 2 millions de personnes. Au fil des ans, les équipes de One Acre Fund ont établi de bonnes relations de travail avec les autorités rwandaises nationales et locales pour préparer l’expansion de leur modèle.  2020-2023 Pour capitaliser sur ces résultats encourageants, nous financerons les activités de One Acre Fund pour trois années supplémentaires, et ainsi permettre à l’organisation d’améliorer la vie d’1,5 million de fermiers d’ici 2022.  32  1/3  des familles de petits agriculteurs du pays"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
      <h1 id="33-no1" class="abs brillcutreg 33-no" style="left: 70px; top: 596px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;"  data-number='{"to": 27, "append": "%"}'></h1>
      <h1 id="33-no1" class="abs brillcutmed 33-no" style="left: 500px; top: 756px; font-size: 2.2em; font-weight:400; margin:0; color:#fff; padding:0; margin:0;"  data-number='{"to": 6329, "comma": "true"}'></h1>
      <img class="halfScale 33-text" style="top:546px; left:183px;" src="/AR2019-20/fr/static/_content/33-text-2.png">        
      <img class="halfScale 33-text" style="top:756px; left:71px;" src="/AR2019-20/fr/static/_content/33-text-3.png">        
      <div class="contentLinkNone abs" style="top: 185px; left: 66px; width: 365px; height: 345px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 535px; left: 177px; width: 464px; height: 161px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 750px; left: 64px; width: 374px; height: 87px;" onclick="Publish.openArticle(12)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim.staggerFromTo(cOf("33-text"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)
          .fromTo(cOf("33-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("33-no")[0]);}}, 1)
          .fromTo(cOf("33-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("33-no")[1]);}}, "+=0.2")
        }

        function onPageLeave() {
          pg33Anim.stop();
          resetNumbers("33-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "Partenaire : Root Capital Pays : Pérou Durée : 2016-2019 > 2019-2022  Plus de prospérité pour les petits fermiers Les petites entreprises agricoles et les coopératives peuvent être de puissants moteurs de prospérité. Lorsqu’elles se développent et s’épanouissent, les centaines de petits agriculteurs qui y sont associés prospèrent et deviennent plus résilients. En effet, ces entreprises ne fournissent pas seulement des moyens vitaux de subsistance, elles agissent aussi comme des catalyseurs de changement en introduisant des pratiques éco-responsables, en investissant dans l’infrastructure locale, en connectant les familles de fermiers à des marchés plus étendus et en renforçant les communautés locales grâce à des emplois, des formations et de meilleurs revenus. Le modèle « crédit plus compétences » de Root Capital permet d’accorder des prêts aux entreprises qui sont trop grandes pour les institutions de microfinance, mais souvent trop petites et à risque pour obtenir des prêts traditionnels auprès des banques commerciales. Ce soutien financier s’accompagne de formations agronomiques et de conseils financiers sur la bonne gestion des prêts, ainsi que de meilleures connexions avec les marchés. Hausse moyenne de  27%  des revenus  Entre 2016 et 2019, nous avons soutenu les efforts de Root Capital pour réduire la pauvreté rurale au Pérou. En trois ans :  62 coopératives rurales ont reçu des prêts et des conseils financiers. Plus de 33 500 petits exploitants ont augmenté leurs revenus de 16%, améliorant ainsi les conditions de vie de plus de 165 000 membres de leur famille. Grace à la pratique de l’agriculture biologique, de la reforestation et de la diversification agricole 52 115 hectares de terre ont été gérés durablement.  2019-2022 Après une première subvention de trois ans, nous renouvelons notre collaboration avec Root Capital au Pérou afin d’offrir des financements sur-mesure et une assistance technique essentielle à 95 coopératives rurales, ce qui bénéficiera à environ 30 000 petits agriculteurs. 33  Dont  6 329 femmes"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 34-text" style="top:693px; left:88px;" src="/AR2019-20/fr/static/_content/34-text-2.png">        
      <img class="halfScale 34-text" style="top:805px; left:88px;" src="/AR2019-20/fr/static/_content/34-text-3.png">        
      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 366px; height: 46px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 136px; left: 321px; width: 326px; height: 46px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 504px; left: 83px; width: 576px; height: 243px;" onclick="Publish.openArticle(12)"></div>
      <div class="contentLinkNone abs" style="top: 800px; left: 83px; width: 576px; height: 37px;" onclick="Publish.openArticle(12)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim.staggerFromTo(cOf("34-text"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)

        }

        function onPageLeave() {
        removeContentLinks();
        Publish.closeArticle();
        }
      `,
      "searchText": "RÉSULTATS ET SUIVI Partenaire : Kheyti Pays : Inde Durée : 2018-2019 > 2019-2022  Développer une serre révolutionnaire L’agriculture indienne est de moins en moins rentable et de plus en plus sensible au climat, alors que le pays entier en dépend pour se nourrir et qu’elle constitue la première source d’emploi de la population. Kheyti conçoit, produit et vend à un prix abordable des serres modulaires innovantes. L’organisation propose également des services de financement, d’accès aux intrants et aux marchés, et des formations pour améliorer les cultures, la récolte et la vente des produits maraîchers. Kheyti est la seule entreprise à offrir aux petits fermiers cette solution de serre tout-en-un. Nous avons financé les activités de Kheyti, initialement sur une année, afin que l’entreprise puisse démontrer l’efficacité de son modèle. Durant cette période, la « Greenhouse-in-a-box » a permis à 50 petits fermiers de multiplier leurs récoltes par 7 en économisant 90% d’eau. Désormais, 125 fermiers sont équipés de la serre développée par Kheyti.  2019-2022 Nous soutenons Kheyti pour lui permettre d’améliorer davantage son produit et ses services tout en se développant pour servir 10 000 petits fermiers d’ici 2022. 34"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
      <h1 id="35-no1" class="abs brillcutreg 35-no" style="left: 70px; top: 581px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;"  data-number='{"to": 57, "append": "%"}'></h1>
      <h1 id="35-no1" class="abs brillcutreg 35-no" style="left: 70px; top: 624px; font-size: 1.6em; font-weight:400; margin:0; color:#e8632f; padding:0; margin:0;"  data-number='{"to": 79, "append": "%"}'></h1>
      <div class="contentLinkNone abs" style="top: 82px; left: 66px; width: 306px; height: 46px;" onclick="Publish.openArticle(13)"></div>
      <div class="contentLinkNone abs" style="top: 154px; left: 390px; width: 256px; height: 553px;" onclick="Publish.openArticle(13)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();
          pg35Anim.fromTo(cOf("35-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("35-no")[0]);}}, 1)
          .fromTo(cOf("35-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("35-no")[1]);}}, "+=0.2")
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg35Anim.stop();
          resetNumbers("35-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "RÉSULTATS Former des microentrepreneurs, investir dans leur avenir À Madagascar, les microentreprises Partenaire : IECD Pays : Madagascar informelles Durée : 2017-2019 constituent la source principale de revenus pour la majorité de la population non agricole. Mais souvent les microentrepreneurs ne disposent pas de compétences en gestion et de la vision à moyen terme nécessaires au maintien de leurs activités au-delà de la première année. Au cours des trois dernières années, l’IECD, en partenariat avec l’ONG locale Madagascar Enterprise Development, a offert à 320 créateurs et responsables de petites entreprises une formation de base en gestion ainsi qu’un suivi personnalisé afin de leur permettre d’évaluer la faisabilité de leurs projets et de pérenniser leurs activités, les rendant ainsi plus rentables. De plus, 75 microentrepreneurs extrêmement vulnérables – vendeurs de rue et entrepreneurs illettrés – ont également appris les principes de base de gestion, ce qui les a aidés à stabiliser leurs revenus.  57%  de participants ont augmenté leurs revenus et  79%  ont commencé à épargner  35"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 256px; left: 86px; width: 573px; height: 48px;" onclick="Publish.openArticle(14)"></div>
      <div class="contentLinkNone abs" style="top: 346px; left: 86px; width: 573px; height: 143px;" onclick="Publish.openArticle(14)"></div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
        removeContentLinks();
        Publish.closeArticle();
        }
      `,
      "searchText": "PROGRAMMES EN  COURS  BLUE VENTURES  MYAGRO  Madagascar – 2018-2021  Sénégal – 2019-2022  Des communautés de pêcheurs s’engagent dans la gestion de leurs ressources avec des fermetures temporaires de zones de pêche permettant aux invertébrés de se reconstituer et aux pécheurs d’augmenter leurs prises et leurs revenus.  PROXIMITY DESIGNS Myanmar – 2018-2020 L’accès aux nouvelles techniques d’irrigation améliore les conditions de vie de 30 000 fermiers du delta d’Ayeyarwady et de la Zone sèche du centre du pays.  36  Les cartes prépayées myAgro permettent à 75 000 fermiers dans 528 villages du Sénégal de payer par petites tranches les intrants agricoles et les formations dont ils ont besoin, augmentant ainsi leurs récoltes en moyenne de 50%."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 319px; left: 86px; width: 203px; height: 335px;" onclick="Publish.openArticle(14)"></div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
        removeContentLinks();
        Publish.closeArticle();
        }
      `,
      "searchText": "EDUCATION FOR EMPLOYMENT Maroc – 2019-2020 430 jeunes Marocains acquièrent des compétences techniques et commerciales et des aptitudes de vie pour augmenter leurs chances de décrocher des postes à responsabilité et de s’assurer des revenus suffisants.  TERRE DES HOMMES SUISSE Pérou – 2017-2020 Une coopérative de cacao de la région amazonienne créée par d’anciens orpailleurs s’attache à améliorer sa production agricole, consolider ses stratégies de vente et ses pratiques de gestion, et atteindre l’autosuffisance.  37"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 39-title" style="top:243px; left:89px;" src="/AR2019-20/fr/static/_content/39-title-1.png">        
      <img class="halfScale 39-sub" style="top:373px; left:368px;" src="/AR2019-20/fr/static/_content/39-sub-1.png">        
      <div class="pointer abs" style="top: 239px; left: 80px; width: 476px; height: 37px;" onclick="Publish.openArticle(15)"></div>
      <div class="pointer abs" style="top: 277px; left: 358px; width: 266px; height: 67px;" onclick="Publish.openArticle(15)"></div>
      <div class="pointer abs" style="top: 364px; left: 358px; width: 283px; height: 307px;" onclick="Publish.openArticle(15)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim.fromTo(cOf("39-title"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("39-sub"), 0.6, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, "-=0.3")
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg39Anim.stop();
        removeContentLinks();
        Publish.closeArticle();
        }
      `,
      "searchText": "RÉPONSE ET PRÉPARATION AUX SITUATIONS D’URGENCE Alors que le monde est aux prises avec la plus grande crise sanitaire depuis un siècle, personne ne doit être laissé pour compte. D’autres épidémies mortelles continuent de faire des ravages, notamment celles d’Ebola ou de la rougeole en République démocratique du Congo. Les services de santé essentiels, en particulier dans les environnements difficiles comme les camps de réfugiés, doivent être maintenus pour sauver des vies et préserver la dignité de chacun."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
      <h1 id="40-no1" class="abs brillcutmed 40-no" style="left: 65px; top: 729px; font-size: 1.8em; font-weight:400; margin:0; color:#1c9788; padding:0; margin:0;"  data-number='{"to": 185800, "comma": "true"}'></h1>
      <div class="contentLinkNone abs" style="top: 82px; left: 81px; width: 583px; height: 46px;" onclick="Publish.openArticle(16)"></div>
      <div class="contentLinkNone abs" style="top: 149px; left: 315px; width: 336px; height: 306px;" onclick="Publish.openArticle(16)"></div>
      <div class="contentLinkNone abs" style="top: 469px; left: 241px; width: 406px; height: 28px;" onclick="Publish.openArticle(16)"></div>
      <div class="contentLinkNone abs" style="top: 499px; left: 241px; width: 416px; height: 338px;" onclick="Publish.openArticle(16)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim.fromTo(cOf("40-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("40-no")[0]);}}, 1)
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg40Anim.stop();
          resetNumbers("40-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "NOUVEAUX  PROGRAMMES  Sauver des vies, protéger des droits  Partenaire : SOS MÉDITERRANÉE Pays : Mer Méditerranée Durée : 2019-2020  Au cours des six dernières années, plus de 20 000 personnes ont péri ou ont disparu en mer entre la Libye et les côtes méridionales de l’Europe, la voie de migration la plus mortelle au monde. SOS MÉDITERRANÉE est une organisation d’aide humanitaire qui depuis 2019 a affrété le navire de sauvetage Ocean Viking. Elle a pour mission de sauver les personnes en détresse en mer, porter assistance aux survivants à bord et témoigner des réalités de la migration dans la région. La filiale suisse s’attache particulièrement au cadre juridique qui vise à clarifier et actualiser le droit international en matière de droits humains en milieu marin. Depuis le début de ses opérations, SOS MÉDITERRANÉE a porté secours à 31 799 survivants.  Soigner dans des contextes d’insécurité En RDC, MSF intervient dans des zones marquées par des difficultés logistiques et l’insécurité pour répondre à deux importantes épidémies d’Ebola et de rougeole. L’épidémie d’Ebola qui a sévit dans les provinces du Nord-Kivu, Sud-Kivu et Ituri en 2018 a été la pire jamais enregistrée dans le pays, avec 3 324 cas confirmés et 2 287 morts. Nous avons soutenu MSF afin d’offrir des soins gratuits à 1 036 patients dans le centre de traitement Ebola de Bunia. Partenaire : Médecins Sans Frontières (MSF) Pays : République Démocratique du Congo, Niger Durée : 2019-2020  185 800 enfants ont été vaccinés  Une épidémie massive de rougeole ravage aussi le pays depuis mi-2018. 310 000 personnes ont été infectées et 6 000 sont mortes au cours de la seule année 2019. Les équipes de MSF ont traité 13 800 patients et ont mis en place un laboratoire d’analyses et des activités de surveillance pour circonscrire l’épidémie. Au Niger, MSF a fourni des soins de qualité à 16 300 enfants dans l’unité pédiatrique de l’hôpital de Magaria. En 2019 plus de 45 000 enfants ont aussi reçu une assistance médicale dans les communautés environnantes. 40"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
      <h1 id="41-no1" class="abs brillcutreg 41-no" style="left: 369px; top: 607px; font-size: 1.6em; font-weight:400; margin:0; color:#1c9788; padding:0; margin:0;"  data-number='{"to": 140000, "comma": "true"}'></h1>
      <div class="contentLinkNone abs" style="top: 153px; left: 361px; width: 286px; height: 437px; " onclick="Publish.openArticle(17)"></div>
      <div class="contentLinkNone abs" style="top: 83px; left: 361px; width: 286px; height: 47px; " onclick="Publish.openArticle(17)"></div>
      <div class="contentLinkNone abs" style="    top: 433px; left: 61px; width: 246px; height: 406px;" onclick="Publish.openArticle(18)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim.fromTo(cOf("41-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("41-no")[0]);}}, 1)
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          pg41Anim.stop();
          resetNumbers("41-no");
        removeContentLinks();
        Publish.closeArticle();
      }
      `,
      "searchText": "RESULTATS Des services de santé pérennes à Cox Bazar Alors que la situation d’urgence dans les camps de réfugiés de Cox Bazar s’est muée en crise humanitaire prolongée, nous avons soutenu BRAC pour rénover et améliorer un centre de santé et deux dispensaires. Ces structures sanitaires offrent des services essentiels de qualité, en particulier dans le domaine de la santé sexuelle et reproductive, la santé néonatale et infantile, dans la prévention de maladies non transmissibles et la santé mentale. L’accès à des infrastructures améliorées représente une importante avancée dans un contexte extrêmement fragile et précaire. Partenaire : BRAC Pays : Bangladesh Durée : 2018-2020  Partenaire : Médecins Sans Frontières (MSF) Pays : Belgique, Espagne, France, Grèce, Italie, Suisse Durée : 2020  Soutenir la réponse à l’épidémie de COVID-19 en Europe  Entre avril 2019 et février 2020 les équipes de BRAC ont assuré 334 000 consultations médicales, 2 300 accouchements sécurisés et 14 000 consultations de planification familiale. Les équipes médicales de BRAC ont dû faire face à un nombre croissant de cas critiques de rougeole et cholera nécessitant des soins intensifs.  Face à la propagation de l’épidémie de coronavirus en Europe, nous avons soutenu les équipes de MSF afin d’aider les autorités sanitaires nationales et renforcer leurs capacités de prévention, contrôle et traitement des cas. Les activités de MSF se sont concentrées sur les populations en situation précaire telles que les résidents des maisons de retraite, les sans domicile fixe, les migrants, les demandeurs d’asile, les détenus et le personnel pénitentiaire. Des équipes mobiles ont procédé à des activités de consultation et dépistage, ainsi que de diagnostic, d’isolement et de prise en charge des cas dans des structures d’hébergement dédiées. MSF a par ailleurs fourni un soutien psychologique aux travailleurs de santé de première ligne.  140 000  réfugiés ont eu accès à des soins de qualité  41"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
      <div class="contentLinkNone abs" style="top: 786px; left: 82px; width: 208px; height: 21px;">
          <a href="https://www.cartierphilanthropy.org/" target="_blank"></a>
        </div>
        `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000);
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Acronymes AUW		 Asian University for Women BRAC 		  Bangladesh Rural Advancement Committee  FICR		 Fédération internationale des sociétés de la Croix-Rouge et du Croissant-Rouge IECD		 Institut Européen de Coopération et de Développement MSF		 Médecins Sans Frontières PAM		 Programme alimentaire mondial SAD		 Swiss Academy for Development SOIL		 Sustainable Organic Integrated Livelihoods WSUP		  Water and Sanitation for the Urban Poor  Crédits photos Cover: © BOMA Project © Azad Foundation (p. 26) © Blue Ventures / Louise Jasper (p. 36) © BOMA Project / David duChemin (p. 22) © Buildher (p. 23) © Cartier Philanthropy / Andrea Borgarello (p. 13, 16, 18-19, 27-31, 41) © Cartier Philanthropy / Cyril Le Tourneur (p. 10-11, 17-21, 23, 26-27, 36) © Cartier Philanthropy / Irene Amodei (p. 38-39) © Education for Employment (p. 37) © Hand in Hand International / Georgina Goodwin (p. 21) © Healthy Learners (p. 12) © IECD (p. 14, 35) © IECD / Rijasolo (p. 17) © Kheyti (p. 34) © Living Goods / Martina Bacigalupo (p. 18) © mothers2mothers / Karin Schermbrucker (p. 24)  Adresse Rue André-De-Garrini 3 - CH-1217 Meyrin-Genève  Site internet www.cartierphilanthropy.org  © MSF / Caroline Thirion (p. 40) © MSF / Clément Mahoudeau (p. 41) © MUSO / Lucas Foglia (p. 15) © myAgro / Christien van den Brink (p. 36) © One Acre Fund / Evariste Babambiki (p. 32) © PAM / Roberto Masiero (p. 18) © PAM / Esther Ouba (p. 18) © Rosie Hallam (p. 19, courtesy of Luminos Fund) © Root Capital (p. 33) © Saha Global (p. 14) © Santé Integrée (p. 19) © SOIL (p. 15) © SOS MÉDITÉRRANÉE / Anthony Jean (p. 40) © StrongMinds / Jennifer Bass (p. 25) © Terre des Hommes Suisse / Jérômine Derigny (p. 37) © Women for Women International / Hazel Thomson (p. 27) © WSUP / Tsilavo Rapiera (p. 18)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = " ";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": null,
  "mobileTemplate": null,
  "articles": [{
    "title": "MESSAGE DU PRÉSIDENT",
    "pageIndex": 7,
    "subIndex": 0,
    "articleIndex": 0,
    "article": `
      <h2 style="color:#1d1d1b">MESSAGE DU PRÉSIDENT</h2>  
      <p>
      Quelle est la place du mécénat d’entreprise dans notre société ?
      </p>
      <p>
      La question est ancienne, et ses réponses multiples.
      </p>
      <p>
      L’engagement philanthropique de Cartier envers la société s’exprime à travers Cartier Philanthropy pour donner une dimension concrète à nos valeurs : générosité, confiance, respect et compassion. La fondation illustre notre implication sans équivoque dans la construction d’un monde plus inclusif et équitable, tout comme Cartier Women’s Initiative et d’autres actions fortes de notre Maison.      </p>
      <p>
      Tout au long de l’année, Cartier Philanthropy s’évertue à apporter des solutions aux défis les plus prégnants dans les régions les moins développées du monde, nous rappelant ainsi que nous avons tous, individus comme entreprises, le potentiel — et donc le devoir — d’agir. À travers ses initiatives, la fondation nous encourage à faire face aux menaces, même les plus redoutables, avec rigueur et détermination. Pas parce que c’est ce que l’on attend de nous. Pas pour faire la une. Mais parce que c’est notre responsabilité de citoyens du monde.
      </p>
      <p>
      À l’heure où j’écris ces lignes, l’humanité affronte la pandémie du coronavirus. Partout, des gens se battent pour endiguer la maladie, sauver des vies, et maintenir leurs moyens de subsistance.      </p>
      <p>
      Le virus nous a rappelé que, quels que soient nos sentiments de faiblesse et de vulnérabilité face au danger, nous sommes toujours entourés de personnes plus vulnérables que nous. Notre aide leur est essentielle.      </p>
      <p>
      Nous ne pouvions donc que nous associer à l’effort humanitaire international déployé en Europe, en Amérique du Nord et du Sud, en Chine, au Moyen-Orient et en Asie du Sud-Est. Cet impératif s’est naturellement imposé dans la logique de l’approche philanthropique de Cartier, enracinée dans la compassion, le pragmatisme et l’ouverture d’esprit.      </p>
      <p>
      Nous n’avons pourtant pas détourné notre attention des plus vulnérables. Comme vous le lirez dans ce rapport, nous avons élargi notre champ d’action pour soutenir le travail fourni sans relâche par Médecins Sans Frontières et d’autres organisations afin de venir en aide à celles et ceux qui sont ou étaient dans le besoin en Italie, en France, en Belgique, en Espagne, en Suisse et en Grèce.      </p>
      <p>
      Une fois encore, Cartier Philanthropy nous a permis de répondre rapidement à une crise sans précédent, unis dans un esprit de solidarité pour agir efficacement en ces temps difficiles.      </p>
      <p>
        <b>Cyrille Vigneron </b><br>
        Président du conseil de fondation, Cartier Philanthropy <br>
      PDG de Cartier<br>
      </p>
    `,
  },{
    "title": "LETTRE DE LA DIRECTRICE EXÉCUTIVE",
    "pageIndex": 8,
    "subIndex": 0,
    "articleIndex": 1,
    "article": `
      <h2 style="color:#1d1d1b">LETTRE DE LA DIRECTRICE EXÉCUTIVE</h2> 
      <p>
      Pendant des mois, le monde entier a retenu son souffle alors que le coronavirus se propageait, évoluait et que nous apprenions à y faire face. 
      </p>
      <p>
      Il serait impossible d’éluder dans cette lettre une des pires crises sanitaires que le monde ait jamais connues, une pandémie dont la portée internationale a peu d’équivalents dans l’Histoire de l’humanité.
      </p>
      <p>
      Cependant, il serait profondément injuste de réduire douze mois de travail passionné à cette urgence, aussi inédite soit-elle.
      </p>
      <p>
      On entend souvent dire que la crise du coronavirus a tout changé, mais, dans certains cas, elle n’a fait qu’accentuer des tendances et des faiblesses existantes, tout en braquant les projecteurs sur les défaillances majeures de notre société. Nombre de ces défis sont ceux auxquels Cartier Philanthropy s’engage à répondre dans le cadre de sa mission en finançant des organisations partenaires extrêmement efficaces dont les actions améliorent concrètement les vies des plus vulnérables.
      </p>
      <p>
      L’identification et le financement d’organisations audacieuses et novatrices avec lesquelles établir des alliances à long terme est au cœur de notre action afin d’assurer un impact social maximal. Nous sommes convaincus qu’il est de notre devoir de les servir au mieux afin qu’elles puissent mettre leurs solutions à la disposition du plus grand nombre. Ces organisations ont besoin non seulement que nous fassions preuve de flexibilité et de pragmatisme, mais aussi que nous prêtions une oreille attentive à leurs besoins et leurs difficultés. En d’autres termes, nous travaillons pour elles, pas l’inverse.
      </p>
      <p>
      Notre manière de procéder n’a pas changé quand le coronavirus a frappé et elle ne changera pas une fois que la crise sera terminée. C’est ce que reflètent les divers partenariats que nous avons renouvelés cette année (8) ainsi que les profils des sept organisations qui ont rejoint notre portfolio. Je vous invite à découvrir leur travail remarquable dans le rapport de cette année.
      </p>
      <p>
        <b>Pascale de la Frégonnière</b><br>
        Directrice exécutive<br>
      </p>
    `,
  },{
    "title": "ACCÈS AUX SERVICES DE BASE",
    "pageIndex": 9,
    "subIndex": 0,
    "articleIndex": 2,
    "article": `
      <h2 style="color:#C9252C">ACCÈS AUX SERVICES DE BASE</h2>  
      <img src="/AR2019-20/fr/static/_content/article-2-1.jpg">
      <p>
      Chaque jour, même en ces temps incertains et difficiles, des organisations s’engagent pour améliorer l’accès  à une éducation de qualité, aux soins  de santé primaires, à l’eau potable,  à une bonne hygiène et à une alimentation équilibrée. Cependant, le rythme de ces améliorations doit s’accélérer si nous voulons faire  en sorte que chaque personne  puisse mener une existence saine  et épanouissante.
      </p>
      
    `,
  },{
    "title": "ACCÈS AUX SERVICES DE BASE: NOUVEAUX PROGRAMMES ",
    "pageIndex": 9,
    "subIndex": 0,
    "articleIndex": 3,
    "article": `
      <h2 style="color:#C9252C">NOUVEAUX PROGRAMMES </h2>  
      
      <h3>Veiller sur la santé des élèves pour leur permettre d’apprendre</h3>
      <img src="/AR2019-20/fr/static/_content/article-3-1.jpg">
      <i>Partenaire : Healthy Learners | Pays : Zambie | Durée : 2019-2022</i>
      <p>
      En Zambie, près de 40 % des enfants en âge d’être scolarisés manquent régulièrement les cours à cause de maladies que l’on peut soigner et éviter, qui affectent leur développement et peuvent entrainer le décrochage scolaire. Healthy Learners aide les écoles à devenir des points d’accès aux soins pour les enfants. Certains professeurs reçoivent une formation d’agent de santé et sont ainsi en mesure de surveiller la santé des élèves, d’évaluer l’état des enfants souffrants, de prodiguer des soins de base et d’envoyer les enfants malades au centre  de santé, ainsi que les jeunes filles nécessitant un suivi  en santé sexuelle et reproductive.
      </p>
      <p>
      Nous soutenons les efforts de Healthy Learners pour  assurer un accès aux soins (38% de réduction de la morbidité) à 285 000 enfants fréquentant les écoles primaires publiques des provinces de Lusaka  et de Copperbelt d’ici 2022.
      
      <h3>Priorité à l’éducation  secondaire des filles </h3>
      <img src="/AR2019-20/fr/static/_content/article-3-2.jpg">
      <i>Partenaire : Room to Read | Pays : Bangladesh, Cambodge | Durée : 2019-2022</i>
      <p>
      Au Bangladesh et au Cambodge, les préjugés culturels, les discriminations de genre, l’insécurité, le besoin de contribuer aux revenus familiaux et l’injonction à se marier et à créer une famille entravent fortement la réussite scolaire des filles, en particulier dans le secondaire.
      </p>
      <p>
      Le programme d’éducation pour les filles de Room to Read permet aux élèves de poursuivre leur scolarité (En 2018, 98% des élèves qui ont bénéficié du programme au Bangladesh et 77% des élèves cambodgiennes ont poursuivi des études supérieures.) plus longtemps et d’acquérir au terme de leurs études secondaires les connaissances, les aptitudes et les capacités qui leur permettront de réussir à l’école et dans la vie. Encadré par des femmes de leurs communautés, le programme propose des séances sur les aptitudes à la vie quotidienne, du mentorat individuel et en groupe, un système de soutien social et une prise en charge qui, selon les besoins, inclut les frais scolaires et de transport, les uniformes et la préparation aux examens.       </p>
      <p>
      Nous soutenons Room to Read afin d’offrir à 4 350 jeunes bangladeshies et cambodgiennes la possibilité de terminer leurs études secondaires et réaliser leur potentiel.
      </p>
      
      <h3>Lutter contre la malnutrition au Guatemala</h3>
      <img src="/AR2019-20/fr/static/_content/article-3-3.jpg">
      <i>Partenaire : Semilla Nueva | Pays : Guatemala | Durée : 2019-2021</i>
      <p>
      Au Guatemala, les tortillas de maïs sont au menu de chaque repas. Malheureusement, elles sont pauvres en nutriments. Semilla Nueva produit et commercialise des semences de maïs bio-fortifiées, enrichies de manière traditionnelle en protéines de qualité et zinc. Les cultures bio-fortifiées constituent une solution efficace et culturellement adaptée contre la malnutrition chronique au Guatemala puisqu’elles n’altèrent pas le régime alimentaire traditionnel.
      </p>
      <p>
      À la suite d’une première subvention de trois ans (Plus de 1 270 sacs de semences ont été vendus en 2018, ce qui signifie que plus de 70 800 personnes ont consommé du maïs enrichi en nutriments pendant un an.),nous renouvelons notre soutien à Semilla Nueva afin  de généraliser la consommation de maïs bio-fortifié  et de fournir à 255  000 personnes du maïs plus riche en nutriments.
      </p>
      
      <h3>Un centre pour les enfants  syriens réfugiés au Liban</h3>
      <img src="/AR2019-20/fr/static/_content/article-3-4.jpg">
      <i>Partenaire : IECD | Pays : Liban | Durée : 2019-2023</i>
      <p>
      Le conflit syrien, qui a entraîné des déplacements massifs de population, fait peser une pression considérable sur les pays d’accueil et plus particulièrement sur leurs systèmes éducatifs. Au Liban, malgré les efforts consentis par le ministère de l’Éducation, qui autorise l’inscription gratuite dans les écoles publiques sans exiger de permis de résidence, plus de 300 000 enfants syriens réfugiés restent non scolarisés.
      </p>
      <p>
      Le Centre Janah à Beyrouth accueille les enfants et adolescents issus de familles défavorisées tant syriennes que libanaises. En proposant un soutien scolaire, des activités extrascolaires et un soutien psychosocial,  le centre aide les enfants à réintégrer l’école et à réussir leur scolarité.
      </p>
      <p>
      Notre contribution permettra à 535 enfants et jeunes pendant trois ans de recevoir un soutien scolaire, participer à des activités de développement personnel et bénéficier également d’un transport gratuit et d’un goûter quotidien.
      </p>
      
      <h3>L’eau propre : une affaire de femme</h3>
      <img src="/AR2019-20/fr/static/_content/article-3-5.jpg">
      <i>Partenaire : Saha Global | Pays : Ghana | Durée : 2019-2022</i>
      <p>
      Dans le nord du Ghana les populations n’ont pas accès à l’eau potable. Les villages dépendent du ruissellement de l’eau de pluie qui s’accumule dans de grands étangs stagnants. Mais cette eau, boueuse et insalubre, représente un risque important pour leur santé.
      </p>
      <p>
      Saha Global s’efforce d’introduire une technologie de traitement de l’eau simple et abordable dans les communautés les plus pauvres et reculées du pays.
      </p>
      <p>
      Son objectif est de former les femmes dans les villages pour qu’elles puissent établir et maintenir des petites entreprises de traitement de l’eau afin d’approvisionner leurs communautés  en eau potable au coût abordable et ainsi générer des revenus. 
      </p>   
      <p>
      Nous soutenons Saha Global pour mettre en place près de  1 000 nouvelles microentreprises de traitement de l’eau destinées  à desservir environ 440 000 personnes d’ici à la fin 2022.      
      </p>   
      
      <h3>La santé n’attend pas </h3>
      <img src="/AR2019-20/fr/static/_content/article-3-6.jpg">
      <i>Partenaire : Muso | Pays : Mali | Durée : 2019-2022</i>
      <p>
      Le Mali présente un des plus haut taux de mortalité des enfants de moins de 5 ans dans le monde. Depuis 2008, Muso collabore avec le gouvernement pour transformer la manière dont les soins de santé sont dispensés afin de pouvoir traiter les malades quelques heures après l’apparition des premiers symptômes. Ce «modèle de soins de santé proactifs » consiste à former des agents de santé communautaire qui se rendent dans les villages pour repérer et soigner gratuitement les personnes malades à domicile, ou les mettre en contact avec des cliniques publiques compétentes.
      </p>
      <p>
      Dans les communautés où ce système a été mis en œuvre, la mortalité des enfants a chuté massivement. (Dans les communautés de la périphérie de Bamako, la mortalité des enfants a été réduite de 93% en  trois ans !)
      </p>
      <p>
      Notre soutien va permettre la constitution d’une équipe technique dédiée auprès de gouvernements, décideurs politiques et personnel de santé au Mali et hors de ses frontières pour assurer l’adoption des soins de santé proactifs.Muso envisage de servir 450 000 patients directement et 18 millions de patients indirectement au cours des trois prochaines années.
      </p>
      
      <h3>Des toilettes écologiques pour une santé durable</h3>
      <img src="/AR2019-20/fr/static/_content/article-3-7.jpg">
      <i>Partenaire : SOIL | Pays : Haïti | Durée : 2019-2022</i>
      <p>
      En Haïti, 66 % des habitants des zones urbaines n’ont pas accès à des installations sanitaires et moins de 1 % des excréments sont traités en toute sécurité. Le manque de toilettes a engendré une crise sanitaire publique majeure : Haïti a le taux de diarrhée infantile le plus élevé au monde. Depuis 2006, SOIL travaille dans le pays pour y promouvoir la santé et des moyens de subsistance durables. Grâce à ses installations sanitaires sûres, l’organisation collecte et transforme les excréments en compost à haute valeur agricole.

      </p>
      <p>
      Nous soutenons SOIL avec l’objectif de fournir à 12  000 Haïtiens des installations sanitaires à faible coût qui associent des toilettes sèches à des services de traitement et de transformation des déchets. 
      </p>

    `,
  },{
    "title": "ACCÈS AUX SERVICES DE BASE: RÉSULTATS",
    "pageIndex": 15,
    "subIndex": 0,
    "articleIndex": 4,
    "article": `
      <h2 style="color:#C9252C">RÉSULTATS</h2>  
      
      <h3>Prévenir le choléra dans les communautés de pêcheurs de l’Ouganda</h3>
      <img src="/AR2019-20/fr/static/_content/article-4-1.jpg">
      <i>Partenaire : FICR | Pays : Ouganda | Durée : 2017-2019</i>
      <p>
      Le choléra est endémique sur les rives  du lac Albert. La pêche constitue  la principale activité économique de la région et l’accès à l’eau et à l’assainissement est extrêmement limité. Nous avons soutenu la Croix-Rouge pour améliorer durablement les conditions de vie et l’état de santé de 10 000 habitants du rift Albertin, au nord-ouest de l’Ouganda, en portant une attention particulière à l’adoption de bonnes pratiques d’hygiène, à l’approvisionnement en eau potable et à l’installation de sanitaires adéquats.
      </p>
      <p>
      Des agents de santé bénévoles de la Croix-Rouge ont sensibilisé à l’hygiène plus de 65 700 personnes,entraînant une hausse de 38 % de  la construction et de l’utilisation  de latrines privées, de sanitaires,  de séchoirs, de points de lavage des mains et de fosses à déchets.
      </p>
      <p>
      La couverture en installations sanitaires des centres de santé et des écoles de la région a été fortement améliorée. (De 51% à 89%).
      </p>
      <p>
      Plus de 9 200 personnesont pu accéder à de l’eau potable grâce à la construction et réhabilitation de 8 puits et l’ajout de 6 kilomètres de conduites au système d’alimentation en eau.
      </p>
      
      <h3>Surmonter les distances pour améliorer la santé des enfants</h3>
      <img src="/AR2019-20/fr/static/_content/article-4-2.jpg">
      <i>Partenaire : Amref | Pays : Sénégal | Durée : 2016-2019</i>
      <p>
      Au Sénégal, la concentration des médecins généralistes et des spécialistes dans les hôpitaux de la capitale entraîne une grande disparité entre les services médicaux et chirurgicaux disponibles à Dakar et dans les zones reculées du Sud.En cinq ans, l’Amref est parvenu à renforcer l’accès aux soins préventifs essentiels ainsi qu’aux soins spécialisés pour plus de 35 000 enfants dans  60 écoles primaires et plus de 50 postes de santé  de Kolda et de Sédhiou. 
      </p>
      <p>
      160 missions de dépistage ont été organisées dans les écoles et les centres de santé pour la détection précoce et le traitement des maladies infantiles les plus communes
      </p>
      <p>
      1 558 enfants ont reçu un suivi médical gratuit et de qualité dans le cadre de 9 camps de chirurgie et 12 mini-camps de consultations spécialisées.

      </p>
      <p>
        37 500 femmes en âge de procréer ont renforcé leurs connaissances et leurs compétences en matière de santé reproductive, santé des enfants, hygiène  et nutrition.
      </p>
      
      <h3>Réduire l’abandon scolaire à Madagascar</h3>
      <img src="/AR2019-20/fr/static/_content/article-4-3.jpg">
      <i>Partenaire : IECD | Pays : Madagascar | Durée : 2017-2019</i>

      <p>
      Le niveau d’instruction à Madagascar compte parmi les plus bas du monde ; les enfants y sont scolarisés en moyenne pendant quatre ans seulement. Dans les communautés rurales, tout juste 19 % des enfants poursuivent des études secondaires  et ils ne sont que 1 % à obtenir leur baccalauréat.
      </p>
      <p>
      Depuis 2006, l’IECD et l’association malgache PROMES collaborent pour réduire le décrochage scolaire dans les communautés rurales en créant des centres de soutien qui proposent un accompagnement individuel scolaire et extrascolaire des élèves. Nous avons financé trois centres  dans la région de Fianarantsoa pour  soutenir 360 élèves (80% ont réussi l’examen  du BEPC alors que le taux  de réussite moyen national s’élève à 53 %.) pendant trois ans.
      </p>
    `,
  },{
    "title": "ACCÈS AUX SERVICES DE BASE: PROGRAMMES EN COURS",
    "pageIndex": 17,
    "subIndex": 0,
    "articleIndex": 5,
    "article": `
      <h2 style="color:#C9252C">PROGRAMMES EN COURS</h2>  
      
      <h3 class="article-mini-header">LIVING GOODS </h3>
      <i>Kenya – 2018-2020</i>
      <p>
      270  agents  de  santé  commu-nautaire   prodiguent   des   soins   de  qualité  à  domicile  à  plus  de  220 000 personnes à l’ouest du Kenya.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-1.jpg">
      
      <h3 class="article-mini-header">WATER AND SANITATION
        FOR THE URBAN POOR</h3>
      <i>Madagascar – 2017-2020</i>
      <p>
      WSUP   collabore   avec   la   com-pagnie   nationale   des   eaux   et   les   communautés   locales   pour   concevoir  des  services  d’appro-visionnement  en  eau  et  d’assai-nissement   desservant   plus   de   60 000 habitants des bidonvilles urbains de Tananarive.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-2.jpg">
      
      <h3 class="article-mini-header">FICR</h3>
      <i>Myanmar, Cambodge –
        2017-2020 </i>
      <p>
      La  Croix-Rouge  collabore  avec  des  communautés  locales  pour  assurer à 36 000 personnes l’ac-cès  à  l’eau  potable,  et  à  39  000  l’accès  à  des  installations  sani-taires  adaptées  et  à  de  bonnes  pratiques d’hygiène.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-3.jpg">
      
      <h3 class="article-mini-header">PROGRAMME ALIMENTAIRE MONDIAL</h3>
      <i>Mozambique – 2017-2020       </i>
      <p>
      2  000  petits  agriculteurs  produi-sant   du   maïs,   des   haricots   et   des  légumes  frais  pour  les  repas  scolaires  découvrent  des  solu-tions  simples  et  abordables  qui  leur permettent de réduire leurs pertes   post-récolte   et   d’aug-menter leurs revenus.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-4.jpg">
      
      <h3 class="article-mini-header">PROGRAMME ALIMENTAIRE MONDIAL</h3>
      <i>Burkina Faso – 2014-2020</i>
      <p>
      Une  chaîne  d’approvisionnement  en produits laitiers dirigée par des femmes  relie  les  petits  éleveurs  et   les   producteurs   locaux   à   71  cantines  scolaires  où  12  500  élèves reçoivent du yaourt frais pour leur collation du matin.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-5.jpg">
      
      <h3 class="article-mini-header">PROGRAMME ALIMENTAIRE MONDIAL</h3>
      <i>Jordanie – 2018-2021 </i>
      <p>
      6  000  enfants  reçoivent  chaque  jour  des  repas  scolaires  grâce  à  l’initiative  «Healthy  Kitchen»  qui  fournit  un  emploi  à  30  réfugiés  syriens et jordaniens en situation précaire.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-6.jpg">
      
      <h3 class="article-mini-header">EDUCATE GIRLS 
      </h3>
      <i>Inde – 2014-2020 </i>
      <p>
      Educate  Girls  stimule  la  scolarisa-tion  des  filles,  promeut  des  infra-structures  éducatives  adaptées  et  améliore  les  résultats  scolaires  de  100 000 enfants dans 1 053 villages du district de Rajsamand.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-7.jpg">
      
      <h3 class="article-mini-header">SANTÉ INTÉGRÉE</h3>
      <i>Togo – 2019-2021</i>
      <p>
      Santé  Intégrée  a  créé  un  modèle  communautaire  abordable  permet-tant  d’assurer  à  240  000  togolais  l’accès aux soins de santé primaires de qualité.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-8.jpg">
      
      <h3 class="article-mini-header">VISIONSPRING 
      </h3>
      <i>Bangladesh – 2018-2021</i>
      <p>
      VisionSpring s’est associé à BRAC au Bangladesh pour fournir des lunettes résistantes,  esthétiques  et  aborda-bles  à  plus  de  600  000  personnes  à  faible revenu.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-9.jpg">
      
      <h3 class="article-mini-header">LUMINOS FUND 
      </h3>
      <i>Éthiopie – 2018-2021 
      </i>
      <p>
      10   000   enfants   éthiopiens   vivant   dans   les   régions   reculées   d’Afar   et  d’Oromiya  réintégreront  l’ensei-gnement  public  au  terme  d’un  pro-gramme d’apprentissage intensif de 10 mois.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-5-10.jpg">
      
    `,
  },{
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES",
    "pageIndex": 21,
    "subIndex": 0,
    "articleIndex": 6,
    "article": `
      <h2 style="color:#16BECF">DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES</h2>  
      <img src="/AR2019-20/fr/static/_content/article-6-1.jpg">
      <p>
      Les inégalités de genre ne sont pas seulement le produit de normes sociales discriminatoires, de déséquilibres de pouvoir et d’obstacles juridiques. Elles racontent aussi — et surtout — l’histoire des partis pris et des préjugés à l’encontre des femmes, portés par les hommes comme  par les femmes, une histoire qui se répète encore et encore.
      </p>
      <p>
      Pour démanteler les inégalités structurelles, nous devons agir à plusieurs niveaux et dans divers contextes — dans les foyers,  les écoles, sur les lieux de travail et dans la fonction publique — en soutenant les femmes et les filles dans leur lutte pour l’obtention de places qui leur reviennent de plein droit.
      </p>
      
    `,
  },{
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: NOUVEAUX PROGRAMMES ",
    "pageIndex": 21,
    "subIndex": 0,
    "articleIndex": 7,
    "article": `
      <h2 style="color:#16BECF">NOUVEAUX PROGRAMMES </h2>  
      
      <h3>Combattre la pauvreté dans les zones arides d’Afrique </h3>
      <img src="/AR2019-20/fr/static/_content/article-7-1.jpg">
      <i>Partenaire : BOMA Project | Pays : Kenya | Durée : 2019-2021</i>
      <p>
      Dans les régions arides et semi-arides du nord du Kenya, des familles d’éleveurs vivent sans eau courante ni électricité, à des kilomètres des commerces, des routes asphaltées, des transports publics, des écoles et des centres de santé les plus proches. Le bétail constitue leur source principale de revenus. Des mois durant, les hommes voyagent loin avec leurs troupeaux à la recherche d’eau et de pâturage, deux ressources rares. Les femmes restent au village, prisonnières d’une pauvreté extrême et d’une insécurité alimentaire chronique.
      </p>
      <p>
      Avec des interventions séquencées qui incluent des formations  pour développer des compétences et des connaissances,  BOMA Project permet aux femmes les plus pauvres de créer des entreprises et des groupes d’épargne (+ 1 400% d’économies), de renforcer la sécurité financière et alimentaire de leur foyer, d’investir dans la santé (+ 258% de dépenses médicales annuelles) et l’éducation de leurs enfants, et d’imposer un peu plus leur voix. Nous soutenons BOMA Project pour permettre à 500 000 femmes  et enfants d’améliorer leurs conditions de vie (+ 147% de revenus des ménages).
      </p>
      
      <h3>Provoquer le changement social en Afrique de l’Ouest</h3>
      <img src="/AR2019-20/fr/static/_content/article-7-2.jpg">
      <i>Partenaire : Tostan | Pays : Gambie, Guinée-Bissau, Sénégal
        | Durée : 2019-2023</i>
      <p>
      Le modèle collaboratif de Tostan favorise le changement social et l’évolution des comportements en engageant un dialogue intra et intercommunautaire approfondi pour sensibiliser jeunes, femmes, hommes, anciens et chefs religieux aux droits humains, à la santé, à l’hygiène, à la résolution de conflit, à l’autonomie économique et au rôle de parent.
      </p>
      <p>
      Ce travail a abouti à l’un des résultats les plus notoires à ce jour : des milliers de communautés (8 830communautés !) ont déclaré publiquement avoir abandonné le mariage précoce et la pratique de l’excision.
      </p>
      
      <h3>Place aux femmes dans  le secteur de la construction </h3>
      <img src="/AR2019-20/fr/static/_content/article-7-3.jpg">
      <i>Partenaire : Buildher | Pays : Kenya | Durée : 2019-2021</i>
      <p>
      En Afrique de l’Est, le secteur de la construction connaît une très forte croissance, mais est aussi l’un des plus affectés par le manque de main-d’œuvre qualifiée. Le programme pilote de Buildher forme des jeunes femmes défavorisées des bidonvilles de Nairobi,  en les aidant à acquérir des compétences très recherchées dans ce domaine, ainsi qu’à obtenir un certificat professionnel reconnu qui leur donnera de meilleures chances de trouver un emploi stable et d’être économiquement indépendantes. En permettant à des femmes qualifiées d’intégrer le secteur de la construction, dominé par les hommes, Buildher contribue à bousculer les attitudes culturelles autour du caractère « genré »  de certains secteurs d’emploi au Kenya.
      </p>
      <p>
      Nous soutenons Buildher pour former 400 jeunes femmes, dont au moins 320 accèderont à un emploi rémunéré.
      </p>
    `,
  },{
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: RÉSULTATS ET  SUIVI",
    "pageIndex": 23,
    "subIndex": 0,
    "articleIndex": 8,
    "article": `
      <h2 style="color:#16BECF">RÉSULTATS ET  SUIVI</h2>  
      
      <h3>Généraliser le modèle  des Mères Mentors en Ouganda </h3>
      <img src="/AR2019-20/fr/static/_content/article-8-1.jpg">
      <i>Partenaire : mothers2mothers | Pays : Ouganda | Durée : 2017-2019 > 2020-2023</i>
      <p>
      mothers2mothers forme et emploie des mères séropositives en tant qu’agents de santé de première ligne. Ces Mères Mentors interviennent dans les communautés les plus défavorisées. Elles travaillent à la fois dans des centres de santé et au sein de leurs communautés pour prodiguer des soins aux femmes, aux enfants, aux adolescents et aux familles toutes entières. Elles facilitent l’accès aux soins, améliorent le maintien des patients dans le système de santé et assurent l’adhérence au traitement en concentrant leurs efforts sur la réduction des infections au VIH (Le taux de  transmission  du VIH de la mère  à son bébé diminue de 40% à 1,3%!) et aux maladies associées.
      </p>
      <p>
      Des éducatrices adolescentes travaillent aussi dans les mêmes communautés que les Mères Mentors pour sensibiliser en particulier les adolescentes et les jeunes femmes aux services de santé sexuelle et reproductive.
      </p>
      <p>
      Entre 2017 et 2019, nous avons soutenu mothers2mothers pour développer son modèle de Mères Mentors dans sept centres de santé et dans les communautés environnantes du centre-est de l’Ouganda.
      </p>
      <p>
      82 Mères Mentors et 36 éducatrices adolescentes sont intervenues auprès de 77 000 femmes et adolescentes, principalement des femmes enceintes ou allaitantes.
      </p>
      <p>
      Les Mères Mentors ont saisi toutes les opportunités au sein de leurs communautés  pour sensibiliser les familles, les informer et les encourager à faire un test de dépistage du VIH.
      </p>
      <p>
      Grâce à leur implication, 2 771 sessions de sensibilisation ont permis d’informer  100 267 personnes.
      </p>
      <h4 class="article-mini-header">2020-2023</h4>
      <p>
      Afin d’accroitre les progrès réalisés grâce à notre premier financement, nous renouvelons notre soutien pour renforcer l’impact du modèle de Mères Mentors (Pour atteindre  167 000 personnes dès la première année!) dans le centre-est de l’Ouganda. mothers2mothers pourra ainsi diversifier les soins proposés et agir dans les domaines de la santé maternelle et infantile, de l’apprentissage précoce, du handicap, ou encore de la santé reproductive des adolescentes.
      </p>
      
      <h3>Soigner les femmes souffrant  de dépression en Zambie </h3>
      <img src="/AR2019-20/fr/static/_content/article-8-2.jpg">
      <i>Partenaire : StrongMinds | Pays : Zambie
        | Durée : 2018-2019 > 2020-2023</i>
      <p>
      La dépression est l’une des maladies les plus négligées dans les pays en voie de développement. En raison du manque d’attention prêtée aux troubles mentaux et des préjugés tenaces qui y sont attachés, rares sont celles et ceux qui peuvent reconnaître leurs symptômes et bénéficier d’une prise en charge. En outre, les services de santé mentale font cruellement défaut dans ces régions.
      </p>
      <p>
      En Ouganda, StrongMinds forme des animateurs en santé mentale chargés d’encadrer des groupes de parole : un modèle unique, simple et éprouvé pour soigner les femmes souffrant de dépression au sein de communautés défavorisées. Au terme de leur thérapie de groupe, 80 % des femmes ne souffrent plus de dépression.
      </p>
      <p>
      Entre 2018 et 2019, nous avons soutenu StrongMinds afin de constituer une équipe pour répliquer le modèle  de l’Ouganda en Zambie.
      </p>
      <p>
      Les résultats sont très encourageants :
      </p>
      <p>
      1 460 femmes vivant à Misisi, un des plus grands bidonvilles de Zambie, ont suivi la thérapie (Au terme  de la thérapie, 76,5% sont parvenues  à vaincre la  dépression) avec succès, ce qui représente 20 % de plus que l’objectif initial. Avec le soutien des nouveaux animateurs en santé mentale, ces femmes ont appris à reconnaître les déclencheurs et les symptômes de la dépression. Une fois les symptômes dépressifs neutralisés, les participantes se nourrissent mieux, présentent une meilleure forme physique et prennent mieux soin de leurs enfants.
      </p>
      <h4 class="article-mini-header">2020-2023</h4>
      <p>
      StrongMinds est aujourd’hui en passe de devenir conseiller technique en santé mentale auprès du ministère zambien de la Santé. 
      </p>
      <p>
      Au cours des trois prochaines années, StrongMinds compte développer son modèle à travers des partenariats et l’intégrer progressivement au système national de santé. L’objectif est de soigner plus de 8  000 femmes.
      </p>
    `,
  },{
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: RÉSULTATS",
    "pageIndex": 25,
    "subIndex": 0,
    "articleIndex": 9,
    "article": `
      <h2 style="color:#16BECF">RÉSULTATS</h2>  
      
      <h3>Des taxis conduits  par des femmes pour les femmes</h3>
      <img src="/AR2019-20/fr/static/_content/article-9-1.jpg">
      <i>Partenaire : Azad Foundation | Pays : Inde | Durée : 2017-2020</i>
      <p>
      Azad Foundation s’attaque aux barrières culturelles et socio-économiques en Inde afin d’ouvrir aux femmes marginalisées l’accès à des métiers non traditionnels.Son programme « Women on Wheels » s’adresse aux femmes vulnérables issues de milieux défavorisés en leur offrant une formation de chauffeur professionnel.
      </p>
      <p>
      En plus de l’apprentissage essentiel de la conduite, cette formation couvre des domaines tels que les droits, l’autodéfense, l’anglais, la présentation personnelle, l’hygiène et l’éducation financière.
      </p>
      <p>
      Entre 2017 et 2020 nous avons soutenu Azad pour identifier et former des femmes vulnérables (Plus de200 ont validé  la formation) issues des quartiers les plus pauvres de Jaipur.
      </p>
      <p>
      Diverses activités ont eu lieu au sein de 225 bidonvilles pour sensibiliser les communautés aux questions d’égalité de genre.  11 346 femmes ont été exposées à ces sessions de mobilisation.
      </p>
      
      <h3>Dépasser le traumatisme</h3>
      <img src="/AR2019-20/fr/static/_content/article-9-2.jpg">
      <i>Partenaire : Swiss Academy for Development | Pays : Myanmar | Durée : 2017-2019</i>
      <p>
      Le Myanmar a été le théâtre de l’une des guerres  civiles les plus longues que le monde ait connu.  Les femmes et les enfants en ont été les premières victimes. Ils souffrent aujourd’hui des conséquences psychologiques de ce traumatisme et vivent dans un climat de violence latente et de peur où silence et impunité règnent en maîtres. 
      </p>
      <p>
      Dans sept villages de Taungû, Swiss Academy for Development et Karen Women Empowerment Group ont permis à des femmes et des jeunes de surmonter leur traumatisme et faire face à leur détresse mentale à travers l’activité physique, la danse et le jeu de rôle.
      </p>
      <p>
      Pendant 350 sessions, 800 participants ont appris à reconnaître les signes d’un traumatisme et ses effets sur leurs vies.
      </p>
      <p>
      Un soutien financier a été accordé à 28 petites activités commerciales et 8 groupes d’épargne et de crédit.
      </p>
      
      <h3>Apporter de  l’espoir aux femmes entrepreneurs</h3>
      <img src="/AR2019-20/fr/static/_content/article-9-3.jpg">
      <i>Partenaire : CREA | Pays : Mexique | Durée : 2016-2019</i>
      <p>
      CREA aide des femmes à développer leurs microentreprises à travers des formations, du mentorat et l’accès à certains services qui leur permettent d’améliorer leurs méthodes de production et de distribution et de trouver de nouveaux débouchés commerciaux. Ce programme de développement commercial a été proposé dans les centres de formation de CREA à Hidalgo, Querétaro, Yucatán, Guerrero et Toluca.
      </p>
      <p>
      Plus de 7 760 femmes ont acquis des nouvelles compétences et ont accédé à de nouvelles sources de financement. Leurs entreprises (Taux  de survie de 82% ) ont réalisé une augmentation de 10% de leurs profits hebdomadaires.
      </p>
      `,
  },{
    "title": "DÉVELOPPEMENT SOCIALET ÉCONOMIQUE DES FEMMES: PROGRAMMES EN COURS",
    "pageIndex": 26,
    "subIndex": 0,
    "articleIndex": 10,
    "article": `
      <h2 style="color:#16BECF">PROGRAMMES EN COURS</h2>  
      
      <h3 class="article-mini-header">ASIAN UNIVERSITY
        FOR WOMEN</h3>
        <i>Bangladesh – 2018-2023 
        </i>
        <p>
        20  jeunes  femmes  de  milieux  très  défavorisés   d’Asie   reçoivent   une   bourse  d’étude  qui  leur  permettra  d’obtenir   un   diplôme   universitaire   et  de  se  faire  une  place  dans  les  sociétés patriarcales de leur pays.
        </p>
      <img src="/AR2019-20/fr/static/_content/article-10-1.jpg">
      
      <h3 class="article-mini-header">WOMEN FOR WOMEN INT. </h3>
      <i>Kosovo et Rwanda
        2017-2020 </i>
        <p>
        1 350 femmes participent à un pro-gramme    complet    d’émancipation    d’une   année   qui   leur   permet   de   sortir  de  la  pauvreté  et  de  l’isole-ment pour atteindre une autonomie économique et sociale.
        </p>
        <img src="/AR2019-20/fr/static/_content/article-10-2.jpg">
        
      <h3 class="article-mini-header">INTERNATIONAL CENTER FOR
        RESEARCH ON WOMEN </h3>
        <i>Rwanda et Tanzanie
          2019-2014 
        </i>
        <p>
        Une  étude  de  terrain  est  en  cours  pour tester des stratégies d’engage-ment  des  hommes  en  les  intégrant  aux   programmes   traditionnels   de   soutien   économique   et   social   des   femmes.  Women  for  Women  Int.  au  Rwanda et Hand in Hand Int. en Tan-zanie  dirigent  ces  programmes  aux-quels  900  femmes  et  470  hommes  participent.
        </p>
        <img src="/AR2019-20/fr/static/_content/article-10-3.jpg">
        
      <h3 class="article-mini-header">MARIE STOPES INT. </h3>
      <i>Sénégal – 2019-2021 </i>
      <p>
      Une équipe mobile offre des services de  santé  sexuelle  et  reproductive  réguliers et gratuits à 12 000 jeunes filles  et  femmes  du  nord-ouest  du  Sénégal.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-10-4.jpg">
    `,
  },{
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES",
    "pageIndex": 27,
    "subIndex": 0,
    "articleIndex": 11,
    "article": `
      <h2 style="color:#F26531">MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES</h2>  
      <img src="/AR2019-20/fr/static/_content/article-11-1.jpg">
      <p>
      Deux tiers des personnes les plus pauvres au monde vivent en zone rurale et souffrent d’un manque d’accès aux marchés, à l’éducation, à des infrastructures de qualité, aux perspectives d’emploi, aux soins médicaux et aux produits financiers.Pour éradiquer l’extrême pauvreté — et la limiter à moins de 3 % de la population mondiale — nous devons en priorité soutenir les petits fermiers partout dans le monde grâce à des modèles éprouvés qui leur permettent d’acquérir les compétences nécessaires, un salaire décent, une sécurité financière afin d’améliorer leur qualité de vie.
      </p>
      
    `,
  },{
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES: RÉSULTATS ET  SUIVI",
    "pageIndex": 29,
    "subIndex": 0,
    "articleIndex": 12,
    "article": `
      <h2 style="color:#F26531">RÉSULTATS ET  SUIVI</h2>  
      
      <h3>Handicap et extrême pauvreté  en Ouganda  </h3>
      <img src="/AR2019-20/fr/static/_content/article-12-1.jpg">
      <i>Partenaire : BRAC | Pays : Ouganda | Durée : 2017-2019 > 2019-2022</i>
      <p>
      Les causes de la pauvreté sont multiples, c’est pourquoi le programme de formation des personnes les plus pauvres de BRAC s’attaque au problème sur plusieurs fronts. Il fournit aux plus démunis des moyens de production, un soutien financier temporaire pour leur consommation journalière, un accompagnement à la création d’entreprise, des plans d’épargne et un coaching aux aptitudes de vie, ainsi qu’un accès gratuit aux soins. En associant encadrement, transfert de connaissances et de compétences ce programme de 24 mois aide les individus et leurs familles à sortir de l’extrême pauvreté.
      </p>
      <p>
      Entre 2016 et 2019, nous avons soutenu l’adaptation de ce programme en Ouganda,  dans les districts extrêmement défavorisés de Luwero et Kiryandongo.
      </p>
      <p>
      1   650 jeunes parmi les plus démunis ne sont plus en situation de pauvreté extrême et disposent de moyens de subsistance pérennes.
      </p>
      <p>
      Ils ont amélioré objectivement leurs revenus, leur consommation,  leurs moyens de production, leur sécurité alimentaire et leur santé,  et ont fait de même pour leurs familles (8 250  personnes  au total).
      </p>
      <p>
      Le programme est axé sur l’incitation à l’épargne chez les jeunes. La formation financière donne aux participants les connaissances et les outils nécessaires pour gérer leur argent et planifier leur avenir : 100 associations villageoises d’épargne et de crédit (Les montants épargnés ont  augmenté de 56,7%) ont été mises sur pied.
      </p>

      <h4 class="article-mini-header">2019-2022</h4>
      <p>
      Nous maintenons notre soutien à BRAC en Ouganda, où l’organisation mène un projet pilote de formation à destination des plus démunis adapté aux personnes handicapées en partenariat avec Handicap International et la National Union of Women with Disabilities of Uganda. Ensemble, ils devraient permettre à 2 700 personnes et leurs familles de sortir de la pauvreté.
      </p>
      
      <h3>Tracer la voie pour sortir de la pauvreté </h3>
      <img src="/AR2019-20/fr/static/_content/article-12-2.jpg">
      <i>Partenaire : Village Enterprise | Pays : Ouganda
        | Durée :  2016-2019 > 2020-2023 </i>
      <p>
      Le programme de formation à la création de microentreprises de Village Enterprise a déjà démontré son efficacité : il permet de sortir les personnes de la pauvreté extrême en les aidant à développer  des moyens de subsistance durables.
      </p>
      <p>
      Les participants, identifiés suite à un classement socio-économique participatif, bénéficient  d’une aide financière, de formations en entrepreneuriat et finance, et d’un mentorat continu avec  un entrepreneur local. Ils reçoivent aussi un soutien à la création de petites activités commerciales  et à la formation de groupes d’épargne et de crédit.
      </p>
      <p>
      Entre 2016 et 2019, 900 entreprises (55%  ont augmenté  leur valeur) de trois personnes ont été créées,  ainsi que 90 groupes d’épargne (311%  d’augmentation  de l’épargne  des foyers), ce qui a permis à 2 700 personnes d’accéder  à l’autonomie sociale et économique.
      </p>
      <h4 class="article-mini-header">2020-2023</h4>
      <p>
      Nous renouvelons notre soutien à Village Enterprise en Ouganda avec l’objectif de fournir à 2   700 personnes parmi les plus démunies, principalement des femmes, les connaissances, les compétences et la confiance nécessaires pour développer des microentreprises durables.
      </p>

      <h3>Des agriculteurs prospères, des communautés dynamiques</h3>
      <img src="/AR2019-20/fr/static/_content/article-12-3.jpg">
      <i>Partenaire : One Acre Fund | Pays : Rwanda
        | Durée :  2016-2019 > 2020-2023 </i>
      <p>
      Le dynamisme des communautés rurales repose sur des petits agriculteurs solides. One Acre Fund propose aux fermiers d’Afrique de l’Est un ensemble de services, dont des semences et engrais améliorés, des financements ainsi que des formations et un accès au marché. Ces services les aident  à augmenter leurs rendements sur une saison et, donc, leur qualité de vie.
      </p>
      <p>
      Entre 2016 et 2019, les actions de One Acre Fund ont permis à  390 000 fermiers rwandais d’augmenter leurs  revenus de 120 dollars en moyenne par an (Près de50% de femmes), améliorant  ainsi la qualité de vie de plus de 2 millions de personnes. Au fil des ans, les équipes de One Acre Fund ont établi de bonnes relations de travail avec les autorités rwandaises nationales et locales pour  préparer l’expansion de leur modèle.
      </p>
      <h4 class="article-mini-header">2019-2023</h4>
      <p>
      Pour capitaliser sur ces résultats encourageants, nous financerons les activités de One Acre Fund pour trois années supplémentaires, et ainsi permettre à l’organisation d’améliorer la vie d’1,5 million de fermiers (1/3 des familles de  petits agriculteurs  du pays) d’ici 2022.
      </p>

      <h3>Plus de prospérité  pour les petits fermiers </h3>
      <img src="/AR2019-20/fr/static/_content/article-12-4.jpg">
      <i>Partenaire : Root Capital | Pays : Pérou
        | Durée : 2016-2019 > 2019-2022 </i>
      <p>
      Les petites entreprises agricoles et les coopératives peuvent être de puissants moteurs de prospérité. Lorsqu’elles se développent et s’épanouissent, les centaines de petits agriculteurs qui y sont associés prospèrent et deviennent plus résilients. En effet, ces entreprises ne fournissent pas seulement des moyens vitaux de subsistance, elles agissent aussi comme des catalyseurs de changement en introduisant des pratiques éco-responsables, en investissant dans l’infrastructure locale, en connectant les familles de fermiers à des marchés plus étendus et en renforçant les communautés locales grâce à des emplois, des formations et de meilleurs revenus. 
      </p>
      <p>
      Le modèle « crédit plus compétences » de Root Capital permet d’accorder des prêts aux entreprises qui sont trop grandes pour les institutions de microfinance, mais souvent trop petites et à risque pour obtenir des prêts traditionnels auprès des banques commerciales. Ce soutien financier s’accompagne de formations agronomiques et de conseils financiers sur la bonne gestion des prêts, ainsi que de meilleures connexions avec les marchés.
      </p>
      <p>
      Entre 2016 et 2019, nous avons soutenu les efforts de Root Capital pour réduire la pauvreté rurale au Pérou. En trois ans :
      </p>
      <p>
      62 coopératives rurales (Hausse moyenne de  27%  des revenus) ont reçu des prêts et des conseils financiers.
      </p>
      <p>
      Plus de 33 500 petits exploitants (Dont6  329    femmes) ont augmenté leurs revenus de 16%, améliorant ainsi les conditions de vie de plus de 165 000 membres de leur famille.
      </p>
      <p>
      Grace à la pratique de l’agriculture biologique, de la reforestation  et de la diversification agricole 52 115 hectares de terre ont été  gérés durablement.
      </p>

      <h4 class="article-mini-header">2019-2022</h4>
      <p>
      Après une première subvention de trois ans, nous renouvelons notre collaboration avec Root Capital au Pérou afin d’offrir des financements sur-mesure et une assistance technique essentielle à 95 coopératives rurales, ce qui bénéficiera à environ 30  000 petits agriculteurs.
      </p>

      <h3>Développer une serre révolutionnaire </h3>
      <img src="/AR2019-20/fr/static/_content/article-12-5.jpg">
      <i>Partenaire : Kheyti | Pays : Inde
        | Durée :  2018-2019 > 2019-2022</i>
      <p>
      L’agriculture indienne est de moins en moins rentable et de plus en plus sensible au climat, alors que le pays entier en dépend pour se nourrir et qu’elle constitue la première source d’emploi de la population.
      </p>
      <p>
      Kheyti conçoit, produit et vend à un prix abordable des serres modulaires innovantes. L’organisation propose également des services de financement, d’accès aux intrants et aux marchés, et des formations pour améliorer les cultures, la récolte et la vente des produits maraîchers.
      </p>
      <p>
      Kheyti est la seule entreprise à offrir aux petits fermiers cette solution de serre tout-en-un.Nous avons financé les activités de Kheyti, initialement sur une année, afin que l’entreprise puisse démontrer l’efficacité de son modèle. 
      </p>
      <p>
      Durant cette période, la « Greenhouse-in-a-box » a permis à 50 petits fermiers de multiplier leurs récoltes par 7 en économisant 90% d’eau. Désormais, 125 fermiers  sont équipés de la serre développée par Kheyti
      </p>
      <h4 class="article-mini-header">2019-2022</h4>
      <p>
      Nous soutenons Kheyti pour lui permettre d’améliorer davantage son produit et ses services  tout en se développant pour servir 10  000 petits fermiers d’ici 2022.
      </p>
    `,
  },{
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES: RÉSULTATS",
    "pageIndex": 34,
    "subIndex": 0,
    "articleIndex": 13,
    "article": `
      <h2 style="color:#F26531">RÉSULTATS</h2>  
      
      <h3>Former des  microentrepreneurs,  investir dans leur avenir  </h3>
      <img src="/AR2019-20/fr/static/_content/article-13-1.jpg">
      <i>Partenaire : IECD | Pays : Madagascar | Durée : 2017-2019</i>
      <p>
      À Madagascar, les microentreprises informelles constituent la source principale de revenus pour la majorité de la population non agricole. Mais souvent  les microentrepreneurs ne disposent pas de compétences en gestion et de la vision à moyen terme nécessaires au maintien de leurs activités au-delà de la première année.
      </p>
      <p>
      Au cours des trois dernières années, l’IECD, en partenariat avec l’ONG locale Madagascar Enterprise Development, a offert à 320 créateurs et responsables de petites entreprises une formation de base en gestion ainsi qu’un suivi personnalisé afin de leur permettre d’évaluer la faisabilité de leurs projets et de pérenniser leurs activités (57% de participants ont augmenté leurs revenus et  79% ont commencé  à épargner), les rendant ainsi plus rentables.
      </p>
      <p>
      De plus, 75 microentrepreneurs extrêmement vulnérables – vendeurs de rue et entrepreneurs illettrés – ont également appris les principes de base de gestion, ce qui les a aidés à stabiliser leurs revenus.
      </p>
      `,
  },{
    "title": "MODES DE  SUB SISTANCE ET ÉCOSYSTÈMES DURABLES: PROGRAMMES EN COURS",
    "pageIndex": 35,
    "subIndex": 0,
    "articleIndex": 14,
    "article": `
      <h2 style="color:#F26531">PROGRAMMES EN COURS</h2>  
      
      <h3 class="article-mini-header">BLUE VENTURES 
      </h3>
        <i>Madagascar – 2018-2021 </i>
        <p>
        Des  communautés  de  pêcheurs  s’engagent   dans   la   gestion   de   leurs  ressources  avec  des  fer-metures  temporaires  de  zones  de   pêche   permettant   aux   in-vertébrés  de  se  reconstituer  et  aux  pécheurs  d’augmenter  leurs  prises et leurs revenus.
        </p>
      <img src="/AR2019-20/fr/static/_content/article-14-1.jpg">
      
      <h3 class="article-mini-header">PROXIMITY DESIGNS 
      </h3>
      <i>Myanmar – 2018-2020</i>
        <p>
        L’accès aux nouvelles techniques d’irrigation   améliore   les   condi-tions  de  vie  de  30  000  fermiers  du  delta  d’Ayeyarwady  et  de  la  Zone sèche du centre du pays.
        </p>
        <img src="/AR2019-20/fr/static/_content/article-14-2.jpg">
        
      <h3 class="article-mini-header">MYAGRO</h3>
        <i>Sénéga – 2019-2022</i>
        <p>
        Les   cartes   prépayées   myAgro   permettent  à  75  000  fermiers  dans   528   villages   du   Sénégal   de   payer   par   petites   tranches les    intrants    agricoles    et    les    formations  dont  ils  ont  besoin,  augmentant  ainsi  leurs  récoltes  en moyenne de 50%.
        </p>
        <img src="/AR2019-20/fr/static/_content/article-14-3.jpg">
        
      <h3 class="article-mini-header">EDUCATION
        FOR EMPLOYMENT </h3>
      <i>Maroc  – 2019-2020</i>
      <p>
      430  jeunes  Marocains  acquièrent  des   compétences   techniques   et   commerciales  et  des  aptitudes  de  vie  pour  augmenter  leurs  chancesde décrocher des postes à responsa-bilité   et   de   s’assurer   des   revenus   suffisants.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-14-4.jpg">
        
      <h3 class="article-mini-header">TERRE DES HOMMES SUISSE </h3>
      <i>Pérou – 2017-2020</i>
      <p>
      Une  coopérative  de  cacao  de  la  région    amazonienne    créée    par    d’anciens   orpailleurs   s’attache   à   améliorer  sa  production  agricole,  consolider ses stratégies de vente et   ses   pratiques   de   gestion,   et   atteindre l’autosuffisance.
      </p>
      <img src="/AR2019-20/fr/static/_content/article-14-5.jpg">
    `,
  },{
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE",
    "pageIndex": 37,
    "subIndex": 0,
    "articleIndex": 15,
    "article": `
      <h2 style="color:#009B8C">RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE</h2>  
      <img src="/AR2019-20/fr/static/_content/article-15-1.jpg">
      <p>
      Alors que le monde est aux prises avec la plus grande crise sanitaire depuis un siècle, personne ne doit être laissé pour compte. D’autres épidémies mortelles continuent de faire des ravages, notamment celles d’Ebola ou de la rougeole en République démocratique du Congo. Les services de santé essentiels, en particulier dans les environnements difficiles comme les camps de réfugiés, doivent être maintenus pour sauver des vies et préserver  la dignité de chacun.
      </p>
      
    `,
  },{
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE: NOUVEAUX PROGRAMMES ",
    "pageIndex": 39,
    "subIndex": 0,
    "articleIndex": 16,
    "article": `
      <h2 style="color:#009B8C">NOUVEAUX PROGRAMMES </h2>  
      
      <h3>Sauver des vies,  protéger des droits</h3>
      <img src="/AR2019-20/fr/static/_content/article-16-1.jpg">
      <i>Partenaire : SOS MÉDITERRANÉE | Pays : Mer Méditerranée | Durée : 2019-2020</i>
      <p>
      Au cours des six dernières années, plus de 20 000 personnes ont péri ou ont disparu en mer entre la Libye et les côtes méridionales de l’Europe, la voie de migration la plus mortelle au monde.
      </p>
      <p>
      SOS MÉDITERRANÉE est une organisation d’aide humanitaire qui depuis 2019 a affrété le navire de sauvetage Ocean Viking. Elle a pour mission de sauver les personnes  en détresse en mer, porter assistance aux survivants à bord  et témoigner des réalités de la migration dans la région.
      </p>
      <p>
      La filiale suisse s’attache particulièrement au cadre juridique qui vise à clarifier et actualiser le droit international en matière de droits humains en milieu marin.
      </p>
      <p>
      Depuis le début de ses opérations, SOS MÉDITERRANÉE  a porté secours à 31 799 survivants.
      </p>
      
      <h3>Soigner dans des contextes d’insécurité</h3>
      <img src="/AR2019-20/fr/static/_content/article-16-2.jpg">
      <i>Partenaire : Médecins Sans Frontières (MSF) | Pays : République Démocratique du Congo, Niger
        | Durée : 2019-2020</i>
        <p>185 800 enfants ont  été vaccinés</p>
      <p>
      En RDC, MSF intervient dans des zones marquées par des difficultés logistiques et l’insécurité pour répondre à deux importantes épidémies d’Ebola et de rougeole. 
      </p>
      <p>
      L’épidémie d’Ebola qui a sévit dans les provinces du Nord-Kivu, Sud-Kivu et Ituri en 2018 a été la pire jamais enregistrée dans le pays, avec 3 324 cas confirmés et 2 287 morts.Nous avons soutenu MSF afin d’offrir des soins gratuits à 1 036 patientsdans le centre de traitement Ebola de Bunia.
      </p>
      <p>
      Une épidémie massive de rougeole ravage aussi le pays depuis mi-2018. 310 000 personnes ont été infectées et 6 000 sont mortes au cours de la seule année 2019.
      </p>
      <p>
      Les équipes de MSF ont traité 13 800 patients et ont mis en place un laboratoire d’analyses et des activités de surveillance pour circonscrire l’épidémie.
      </p>
      <p>
      Au Niger, MSF a fourni des soins de qualité à 16 300 enfants dans l’unité pédiatrique de l’hôpital de Magaria. En 2019 plus de 45 000 enfants ont aussi reçu une assistance médicale dans les communautés environnantes.       
      </p>
    `,
  },{
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE: RÉSULTATS ",
    "pageIndex": 40,
    "subIndex": 0,
    "articleIndex": 17,
    "article": `
      <h2 style="color:#009B8C">RÉSULTATS </h2>  
      
      <h3>Des services de santé  pérennes à Cox Bazar</h3>
      <img src="/AR2019-20/fr/static/_content/article-17-2.jpg">
      <i>Partenaire : BRAC | Pays : Bangladesh | Durée : 2018-2020</i>
      <p>
      Alors que la situation d’urgence dans les camps de réfugiés de Cox Bazar s’est muée en crise humanitaire prolongée, nous avons soutenu BRAC pour rénover et améliorer un centre de santé et deux dispensaires. Ces structures sanitaires offrent des services essentiels de qualité, en particulier dans le domaine de la santé sexuelle et reproductive, la santé néonatale et infantile, dans la prévention de maladies non transmissibles et la santé mentale.
      </p>
      <p>
      L’accès à des infrastructures améliorées représente une importante avancée dans un contexte extrêmement fragile et précaire. Entre avril 2019 et février 2020 les équipes de BRAC ont assuré 334 000 consultations médicales, 2 300 accouchements sécurisés et  14 000 consultations de planification familiale. Les équipes médicales de BRAC ont dû faire face à un nombre croissant de cas critiques de rougeole et cholera nécessitant des soins intensifs.
      </p>
      <p>
      140 000 réfugiés ont eu accès à des soins de qualité
      </p>
    `,
  },{
    "title": "RÉPONSE ET  PRÉ PARATION AUX SITUATIONS D’URGENCE: RÉSULTATS - COVID-19 ",
    "pageIndex": 40,
    "subIndex": 0,
    "articleIndex": 18,
    "article": `
      <h2 style="color:#009B8C">RÉSULTATS </h2>  

      <h3>Soutenir la réponse  à l’épidémie de  COVID-19 en Europe</h3>
      <img src="/AR2019-20/fr/static/_content/article-17-1.jpg">
      <i>Partenaire : Médecins Sans Frontières (MSF) | Pays : Belgique, Espagne, France, Grèce, Italie, Suisse
        | Durée : 2020</i>
      <p>
      Face à la propagation de l’épidémie de coronavirus en Europe, nous avons soutenu les équipes de MSF afin d’aider les autorités sanitaires nationales et renforcer leurs capacités de prévention, contrôle et traitement des cas.
      </p>
      <p>
      Les activités de MSF se sont concentrées sur les populations en situation précaire telles que les résidents des maisons de retraite, les sans domicile fixe, les migrants, les demandeurs d’asile, les détenus et le personnel pénitentiaire.Des équipes mobiles ont procédé à des activités de consultation et dépistage, ainsi que de diagnostic, d’isolement et de prise en charge des cas dans des structures d’hébergement dédiées.
      </p>
      <p>
      MSF a par ailleurs fourni un soutien psychologique aux travailleurs de santé de première ligne.
      </p>
    `,
  }
  ],}


// WEBPACK FOOTER //
// ./src/document.js